2025

/************************************************************************
 設定：旧地理院地図より https://maps.gsi.go.jp/js/muni.js
 ************************************************************************/
const muni = {}
muni['1100'] = '1,北海道,1100,札幌市'
muni['1101'] = '1,北海道,1101,札幌市　中央区'
muni['1102'] = '1,北海道,1102,札幌市　北区'
muni['1103'] = '1,北海道,1103,札幌市　東区'
muni['1104'] = '1,北海道,1104,札幌市　白石区'
muni['1105'] = '1,北海道,1105,札幌市　豊平区'
muni['1106'] = '1,北海道,1106,札幌市　南区'
muni['1107'] = '1,北海道,1107,札幌市　西区'
muni['1108'] = '1,北海道,1108,札幌市　厚別区'
muni['1109'] = '1,北海道,1109,札幌市　手稲区'
muni['1110'] = '1,北海道,1110,札幌市　清田区'
muni['1202'] = '1,北海道,1202,函館市'
muni['1203'] = '1,北海道,1203,小樽市'
muni['1204'] = '1,北海道,1204,旭川市'
muni['1205'] = '1,北海道,1205,室蘭市'
muni['1206'] = '1,北海道,1206,釧路市'
muni['1207'] = '1,北海道,1207,帯広市'
muni['1208'] = '1,北海道,1208,北見市'
muni['1209'] = '1,北海道,1209,夕張市'
muni['1210'] = '1,北海道,1210,岩見沢市'
muni['1211'] = '1,北海道,1211,網走市'
muni['1212'] = '1,北海道,1212,留萌市'
muni['1213'] = '1,北海道,1213,苫小牧市'
muni['1214'] = '1,北海道,1214,稚内市'
muni['1215'] = '1,北海道,1215,美唄市'
muni['1216'] = '1,北海道,1216,芦別市'
muni['1217'] = '1,北海道,1217,江別市'
muni['1218'] = '1,北海道,1218,赤平市'
muni['1219'] = '1,北海道,1219,紋別市'
muni['1220'] = '1,北海道,1220,士別市'
muni['1221'] = '1,北海道,1221,名寄市'
muni['1222'] = '1,北海道,1222,三笠市'
muni['1223'] = '1,北海道,1223,根室市'
muni['1224'] = '1,北海道,1224,千歳市'
muni['1225'] = '1,北海道,1225,滝川市'
muni['1226'] = '1,北海道,1226,砂川市'
muni['1227'] = '1,北海道,1227,歌志内市'
muni['1228'] = '1,北海道,1228,深川市'
muni['1229'] = '1,北海道,1229,富良野市'
muni['1230'] = '1,北海道,1230,登別市'
muni['1231'] = '1,北海道,1231,恵庭市'
muni['1233'] = '1,北海道,1233,伊達市'
muni['1234'] = '1,北海道,1234,北広島市'
muni['1235'] = '1,北海道,1235,石狩市'
muni['1236'] = '1,北海道,1236,北斗市'
muni['1303'] = '1,北海道,1303,当別町'
muni['1304'] = '1,北海道,1304,新篠津村'
muni['1331'] = '1,北海道,1331,松前町'
muni['1332'] = '1,北海道,1332,福島町'
muni['1333'] = '1,北海道,1333,知内町'
muni['1334'] = '1,北海道,1334,木古内町'
muni['1337'] = '1,北海道,1337,七飯町'
muni['1343'] = '1,北海道,1343,鹿部町'
muni['1345'] = '1,北海道,1345,森町'
muni['1346'] = '1,北海道,1346,八雲町'
muni['1347'] = '1,北海道,1347,長万部町'
muni['1361'] = '1,北海道,1361,江差町'
muni['1362'] = '1,北海道,1362,上ノ国町'
muni['1363'] = '1,北海道,1363,厚沢部町'
muni['1364'] = '1,北海道,1364,乙部町'
muni['1367'] = '1,北海道,1367,奥尻町'
muni['1370'] = '1,北海道,1370,今金町'
muni['1371'] = '1,北海道,1371,せたな町'
muni['1391'] = '1,北海道,1391,島牧村'
muni['1392'] = '1,北海道,1392,寿都町'
muni['1393'] = '1,北海道,1393,黒松内町'
muni['1394'] = '1,北海道,1394,蘭越町'
muni['1395'] = '1,北海道,1395,ニセコ町'
muni['1396'] = '1,北海道,1396,真狩村'
muni['1397'] = '1,北海道,1397,留寿都村'
muni['1398'] = '1,北海道,1398,喜茂別町'
muni['1399'] = '1,北海道,1399,京極町'
muni['1400'] = '1,北海道,1400,倶知安町'
muni['1401'] = '1,北海道,1401,共和町'
muni['1402'] = '1,北海道,1402,岩内町'
muni['1403'] = '1,北海道,1403,泊村'
muni['1404'] = '1,北海道,1404,神恵内村'
muni['1405'] = '1,北海道,1405,積丹町'
muni['1406'] = '1,北海道,1406,古平町'
muni['1407'] = '1,北海道,1407,仁木町'
muni['1408'] = '1,北海道,1408,余市町'
muni['1409'] = '1,北海道,1409,赤井川村'
muni['1423'] = '1,北海道,1423,南幌町'
muni['1424'] = '1,北海道,1424,奈井江町'
muni['1425'] = '1,北海道,1425,上砂川町'
muni['1427'] = '1,北海道,1427,由仁町'
muni['1428'] = '1,北海道,1428,長沼町'
muni['1429'] = '1,北海道,1429,栗山町'
muni['1430'] = '1,北海道,1430,月形町'
muni['1431'] = '1,北海道,1431,浦臼町'
muni['1432'] = '1,北海道,1432,新十津川町'
muni['1433'] = '1,北海道,1433,妹背牛町'
muni['1434'] = '1,北海道,1434,秩父別町'
muni['1436'] = '1,北海道,1436,雨竜町'
muni['1437'] = '1,北海道,1437,北竜町'
muni['1438'] = '1,北海道,1438,沼田町'
muni['1452'] = '1,北海道,1452,鷹栖町'
muni['1453'] = '1,北海道,1453,東神楽町'
muni['1454'] = '1,北海道,1454,当麻町'
muni['1455'] = '1,北海道,1455,比布町'
muni['1456'] = '1,北海道,1456,愛別町'
muni['1457'] = '1,北海道,1457,上川町'
muni['1458'] = '1,北海道,1458,東川町'
muni['1459'] = '1,北海道,1459,美瑛町'
muni['1460'] = '1,北海道,1460,上富良野町'
muni['1461'] = '1,北海道,1461,中富良野町'
muni['1462'] = '1,北海道,1462,南富良野町'
muni['1463'] = '1,北海道,1463,占冠村'
muni['1464'] = '1,北海道,1464,和寒町'
muni['1465'] = '1,北海道,1465,剣淵町'
muni['1468'] = '1,北海道,1468,下川町'
muni['1469'] = '1,北海道,1469,美深町'
muni['1470'] = '1,北海道,1470,音威子府村'
muni['1471'] = '1,北海道,1471,中川町'
muni['1472'] = '1,北海道,1472,幌加内町'
muni['1481'] = '1,北海道,1481,増毛町'
muni['1482'] = '1,北海道,1482,小平町'
muni['1483'] = '1,北海道,1483,苫前町'
muni['1484'] = '1,北海道,1484,羽幌町'
muni['1485'] = '1,北海道,1485,初山別村'
muni['1486'] = '1,北海道,1486,遠別町'
muni['1487'] = '1,北海道,1487,天塩町'
muni['1511'] = '1,北海道,1511,猿払村'
muni['1512'] = '1,北海道,1512,浜頓別町'
muni['1513'] = '1,北海道,1513,中頓別町'
muni['1514'] = '1,北海道,1514,枝幸町'
muni['1516'] = '1,北海道,1516,豊富町'
muni['1517'] = '1,北海道,1517,礼文町'
muni['1518'] = '1,北海道,1518,利尻町'
muni['1519'] = '1,北海道,1519,利尻富士町'
muni['1520'] = '1,北海道,1520,幌延町'
muni['1543'] = '1,北海道,1543,美幌町'
muni['1544'] = '1,北海道,1544,津別町'
muni['1545'] = '1,北海道,1545,斜里町'
muni['1546'] = '1,北海道,1546,清里町'
muni['1547'] = '1,北海道,1547,小清水町'
muni['1549'] = '1,北海道,1549,訓子府町'
muni['1550'] = '1,北海道,1550,置戸町'
muni['1552'] = '1,北海道,1552,佐呂間町'
muni['1555'] = '1,北海道,1555,遠軽町'
muni['1559'] = '1,北海道,1559,湧別町'
muni['1560'] = '1,北海道,1560,滝上町'
muni['1561'] = '1,北海道,1561,興部町'
muni['1562'] = '1,北海道,1562,西興部村'
muni['1563'] = '1,北海道,1563,雄武町'
muni['1564'] = '1,北海道,1564,大空町'
muni['1571'] = '1,北海道,1571,豊浦町'
muni['1575'] = '1,北海道,1575,壮瞥町'
muni['1578'] = '1,北海道,1578,白老町'
muni['1581'] = '1,北海道,1581,厚真町'
muni['1584'] = '1,北海道,1584,洞爺湖町'
muni['1585'] = '1,北海道,1585,安平町'
muni['1586'] = '1,北海道,1586,むかわ町'
muni['1601'] = '1,北海道,1601,日高町'
muni['1602'] = '1,北海道,1602,平取町'
muni['1604'] = '1,北海道,1604,新冠町'
muni['1607'] = '1,北海道,1607,浦河町'
muni['1608'] = '1,北海道,1608,様似町'
muni['1609'] = '1,北海道,1609,えりも町'
muni['1610'] = '1,北海道,1610,新ひだか町'
muni['1631'] = '1,北海道,1631,音更町'
muni['1632'] = '1,北海道,1632,士幌町'
muni['1633'] = '1,北海道,1633,上士幌町'
muni['1634'] = '1,北海道,1634,鹿追町'
muni['1635'] = '1,北海道,1635,新得町'
muni['1636'] = '1,北海道,1636,清水町'
muni['1637'] = '1,北海道,1637,芽室町'
muni['1638'] = '1,北海道,1638,中札内村'
muni['1639'] = '1,北海道,1639,更別村'
muni['1641'] = '1,北海道,1641,大樹町'
muni['1642'] = '1,北海道,1642,広尾町'
muni['1643'] = '1,北海道,1643,幕別町'
muni['1644'] = '1,北海道,1644,池田町'
muni['1645'] = '1,北海道,1645,豊頃町'
muni['1646'] = '1,北海道,1646,本別町'
muni['1647'] = '1,北海道,1647,足寄町'
muni['1648'] = '1,北海道,1648,陸別町'
muni['1649'] = '1,北海道,1649,浦幌町'
muni['1661'] = '1,北海道,1661,釧路町'
muni['1662'] = '1,北海道,1662,厚岸町'
muni['1663'] = '1,北海道,1663,浜中町'
muni['1664'] = '1,北海道,1664,標茶町'
muni['1665'] = '1,北海道,1665,弟子屈町'
muni['1667'] = '1,北海道,1667,鶴居村'
muni['1668'] = '1,北海道,1668,白糠町'
muni['1691'] = '1,北海道,1691,別海町'
muni['1692'] = '1,北海道,1692,中標津町'
muni['1693'] = '1,北海道,1693,標津町'
muni['1694'] = '1,北海道,1694,羅臼町'
muni['1695'] = '1,北海道,1695,色丹村'
muni['1696'] = '1,北海道,1696,泊村'
muni['1697'] = '1,北海道,1697,留夜別村'
muni['1698'] = '1,北海道,1698,留別村'
muni['1699'] = '1,北海道,1699,紗那村'
muni['1700'] = '1,北海道,1700,蘂取村'
muni['2201'] = '2,青森県,2201,青森市'
muni['2202'] = '2,青森県,2202,弘前市'
muni['2203'] = '2,青森県,2203,八戸市'
muni['2204'] = '2,青森県,2204,黒石市'
muni['2205'] = '2,青森県,2205,五所川原市'
muni['2206'] = '2,青森県,2206,十和田市'
muni['2207'] = '2,青森県,2207,三沢市'
muni['2208'] = '2,青森県,2208,むつ市'
muni['2209'] = '2,青森県,2209,つがる市'
muni['2210'] = '2,青森県,2210,平川市'
muni['2301'] = '2,青森県,2301,平内町'
muni['2303'] = '2,青森県,2303,今別町'
muni['2304'] = '2,青森県,2304,蓬田村'
muni['2307'] = '2,青森県,2307,外ヶ浜町'
muni['2321'] = '2,青森県,2321,鰺ヶ沢町'
muni['2323'] = '2,青森県,2323,深浦町'
muni['2343'] = '2,青森県,2343,西目屋村'
muni['2361'] = '2,青森県,2361,藤崎町'
muni['2362'] = '2,青森県,2362,大鰐町'
muni['2367'] = '2,青森県,2367,田舎館村'
muni['2381'] = '2,青森県,2381,板柳町'
muni['2384'] = '2,青森県,2384,鶴田町'
muni['2387'] = '2,青森県,2387,中泊町'
muni['2401'] = '2,青森県,2401,野辺地町'
muni['2402'] = '2,青森県,2402,七戸町'
muni['2405'] = '2,青森県,2405,六戸町'
muni['2406'] = '2,青森県,2406,横浜町'
muni['2408'] = '2,青森県,2408,東北町'
muni['2411'] = '2,青森県,2411,六ヶ所村'
muni['2412'] = '2,青森県,2412,おいらせ町'
muni['2423'] = '2,青森県,2423,大間町'
muni['2424'] = '2,青森県,2424,東通村'
muni['2425'] = '2,青森県,2425,風間浦村'
muni['2426'] = '2,青森県,2426,佐井村'
muni['2441'] = '2,青森県,2441,三戸町'
muni['2442'] = '2,青森県,2442,五戸町'
muni['2443'] = '2,青森県,2443,田子町'
muni['2445'] = '2,青森県,2445,南部町'
muni['2446'] = '2,青森県,2446,階上町'
muni['2450'] = '2,青森県,2450,新郷村'
muni['3201'] = '3,岩手県,3201,盛岡市'
muni['3202'] = '3,岩手県,3202,宮古市'
muni['3203'] = '3,岩手県,3203,大船渡市'
muni['3205'] = '3,岩手県,3205,花巻市'
muni['3206'] = '3,岩手県,3206,北上市'
muni['3207'] = '3,岩手県,3207,久慈市'
muni['3208'] = '3,岩手県,3208,遠野市'
muni['3209'] = '3,岩手県,3209,一関市'
muni['3210'] = '3,岩手県,3210,陸前高田市'
muni['3211'] = '3,岩手県,3211,釜石市'
muni['3213'] = '3,岩手県,3213,二戸市'
muni['3214'] = '3,岩手県,3214,八幡平市'
muni['3215'] = '3,岩手県,3215,奥州市'
muni['3216'] = '3,岩手県,3216,滝沢市'
muni['3301'] = '3,岩手県,3301,雫石町'
muni['3302'] = '3,岩手県,3302,葛巻町'
muni['3303'] = '3,岩手県,3303,岩手町'
muni['3321'] = '3,岩手県,3321,紫波町'
muni['3322'] = '3,岩手県,3322,矢巾町'
muni['3366'] = '3,岩手県,3366,西和賀町'
muni['3381'] = '3,岩手県,3381,金ケ崎町'
muni['3402'] = '3,岩手県,3402,平泉町'
muni['3441'] = '3,岩手県,3441,住田町'
muni['3461'] = '3,岩手県,3461,大槌町'
muni['3482'] = '3,岩手県,3482,山田町'
muni['3483'] = '3,岩手県,3483,岩泉町'
muni['3484'] = '3,岩手県,3484,田野畑村'
muni['3485'] = '3,岩手県,3485,普代村'
muni['3501'] = '3,岩手県,3501,軽米町'
muni['3503'] = '3,岩手県,3503,野田村'
muni['3506'] = '3,岩手県,3506,九戸村'
muni['3507'] = '3,岩手県,3507,洋野町'
muni['3524'] = '3,岩手県,3524,一戸町'
muni['4100'] = '4,宮城県,4100,仙台市'
muni['4101'] = '4,宮城県,4101,仙台市　青葉区'
muni['4102'] = '4,宮城県,4102,仙台市　宮城野区'
muni['4103'] = '4,宮城県,4103,仙台市　若林区'
muni['4104'] = '4,宮城県,4104,仙台市　太白区'
muni['4105'] = '4,宮城県,4105,仙台市　泉区'
muni['4202'] = '4,宮城県,4202,石巻市'
muni['4203'] = '4,宮城県,4203,塩竈市'
muni['4205'] = '4,宮城県,4205,気仙沼市'
muni['4206'] = '4,宮城県,4206,白石市'
muni['4207'] = '4,宮城県,4207,名取市'
muni['4208'] = '4,宮城県,4208,角田市'
muni['4209'] = '4,宮城県,4209,多賀城市'
muni['4211'] = '4,宮城県,4211,岩沼市'
muni['4212'] = '4,宮城県,4212,登米市'
muni['4213'] = '4,宮城県,4213,栗原市'
muni['4214'] = '4,宮城県,4214,東松島市'
muni['4215'] = '4,宮城県,4215,大崎市'
muni['4216'] = '4,宮城県,4216,富谷市'
muni['4301'] = '4,宮城県,4301,蔵王町'
muni['4302'] = '4,宮城県,4302,七ケ宿町'
muni['4321'] = '4,宮城県,4321,大河原町'
muni['4322'] = '4,宮城県,4322,村田町'
muni['4323'] = '4,宮城県,4323,柴田町'
muni['4324'] = '4,宮城県,4324,川崎町'
muni['4341'] = '4,宮城県,4341,丸森町'
muni['4361'] = '4,宮城県,4361,亘理町'
muni['4362'] = '4,宮城県,4362,山元町'
muni['4401'] = '4,宮城県,4401,松島町'
muni['4404'] = '4,宮城県,4404,七ヶ浜町'
muni['4406'] = '4,宮城県,4406,利府町'
muni['4421'] = '4,宮城県,4421,大和町'
muni['4422'] = '4,宮城県,4422,大郷町'
muni['4423'] = '4,宮城県,4423,富谷市'
muni['4424'] = '4,宮城県,4424,大衡村'
muni['4444'] = '4,宮城県,4444,色麻町'
muni['4445'] = '4,宮城県,4445,加美町'
muni['4501'] = '4,宮城県,4501,涌谷町'
muni['4505'] = '4,宮城県,4505,美里町'
muni['4581'] = '4,宮城県,4581,女川町'
muni['4606'] = '4,宮城県,4606,南三陸町'
muni['5201'] = '5,秋田県,5201,秋田市'
muni['5202'] = '5,秋田県,5202,能代市'
muni['5203'] = '5,秋田県,5203,横手市'
muni['5204'] = '5,秋田県,5204,大館市'
muni['5206'] = '5,秋田県,5206,男鹿市'
muni['5207'] = '5,秋田県,5207,湯沢市'
muni['5209'] = '5,秋田県,5209,鹿角市'
muni['5210'] = '5,秋田県,5210,由利本荘市'
muni['5211'] = '5,秋田県,5211,潟上市'
muni['5212'] = '5,秋田県,5212,大仙市'
muni['5213'] = '5,秋田県,5213,北秋田市'
muni['5214'] = '5,秋田県,5214,にかほ市'
muni['5215'] = '5,秋田県,5215,仙北市'
muni['5303'] = '5,秋田県,5303,小坂町'
muni['5327'] = '5,秋田県,5327,上小阿仁村'
muni['5346'] = '5,秋田県,5346,藤里町'
muni['5348'] = '5,秋田県,5348,三種町'
muni['5349'] = '5,秋田県,5349,八峰町'
muni['5361'] = '5,秋田県,5361,五城目町'
muni['5363'] = '5,秋田県,5363,八郎潟町'
muni['5366'] = '5,秋田県,5366,井川町'
muni['5368'] = '5,秋田県,5368,大潟村'
muni['5434'] = '5,秋田県,5434,美郷町'
muni['5463'] = '5,秋田県,5463,羽後町'
muni['5464'] = '5,秋田県,5464,東成瀬村'
muni['6201'] = '6,山形県,6201,山形市'
muni['6202'] = '6,山形県,6202,米沢市'
muni['6203'] = '6,山形県,6203,鶴岡市'
muni['6204'] = '6,山形県,6204,酒田市'
muni['6205'] = '6,山形県,6205,新庄市'
muni['6206'] = '6,山形県,6206,寒河江市'
muni['6207'] = '6,山形県,6207,上山市'
muni['6208'] = '6,山形県,6208,村山市'
muni['6209'] = '6,山形県,6209,長井市'
muni['6210'] = '6,山形県,6210,天童市'
muni['6211'] = '6,山形県,6211,東根市'
muni['6212'] = '6,山形県,6212,尾花沢市'
muni['6213'] = '6,山形県,6213,南陽市'
muni['6301'] = '6,山形県,6301,山辺町'
muni['6302'] = '6,山形県,6302,中山町'
muni['6321'] = '6,山形県,6321,河北町'
muni['6322'] = '6,山形県,6322,西川町'
muni['6323'] = '6,山形県,6323,朝日町'
muni['6324'] = '6,山形県,6324,大江町'
muni['6341'] = '6,山形県,6341,大石田町'
muni['6361'] = '6,山形県,6361,金山町'
muni['6362'] = '6,山形県,6362,最上町'
muni['6363'] = '6,山形県,6363,舟形町'
muni['6364'] = '6,山形県,6364,真室川町'
muni['6365'] = '6,山形県,6365,大蔵村'
muni['6366'] = '6,山形県,6366,鮭川村'
muni['6367'] = '6,山形県,6367,戸沢村'
muni['6381'] = '6,山形県,6381,高畠町'
muni['6382'] = '6,山形県,6382,川西町'
muni['6401'] = '6,山形県,6401,小国町'
muni['6402'] = '6,山形県,6402,白鷹町'
muni['6403'] = '6,山形県,6403,飯豊町'
muni['6426'] = '6,山形県,6426,三川町'
muni['6428'] = '6,山形県,6428,庄内町'
muni['6461'] = '6,山形県,6461,遊佐町'
muni['7201'] = '7,福島県,7201,福島市'
muni['7202'] = '7,福島県,7202,会津若松市'
muni['7203'] = '7,福島県,7203,郡山市'
muni['7204'] = '7,福島県,7204,いわき市'
muni['7205'] = '7,福島県,7205,白河市'
muni['7207'] = '7,福島県,7207,須賀川市'
muni['7208'] = '7,福島県,7208,喜多方市'
muni['7209'] = '7,福島県,7209,相馬市'
muni['7210'] = '7,福島県,7210,二本松市'
muni['7211'] = '7,福島県,7211,田村市'
muni['7212'] = '7,福島県,7212,南相馬市'
muni['7213'] = '7,福島県,7213,伊達市'
muni['7214'] = '7,福島県,7214,本宮市'
muni['7301'] = '7,福島県,7301,桑折町'
muni['7303'] = '7,福島県,7303,国見町'
muni['7308'] = '7,福島県,7308,川俣町'
muni['7322'] = '7,福島県,7322,大玉村'
muni['7342'] = '7,福島県,7342,鏡石町'
muni['7344'] = '7,福島県,7344,天栄村'
muni['7362'] = '7,福島県,7362,下郷町'
muni['7364'] = '7,福島県,7364,檜枝岐村'
muni['7367'] = '7,福島県,7367,只見町'
muni['7368'] = '7,福島県,7368,南会津町'
muni['7402'] = '7,福島県,7402,北塩原村'
muni['7405'] = '7,福島県,7405,西会津町'
muni['7407'] = '7,福島県,7407,磐梯町'
muni['7408'] = '7,福島県,7408,猪苗代町'
muni['7421'] = '7,福島県,7421,会津坂下町'
muni['7422'] = '7,福島県,7422,湯川村'
muni['7423'] = '7,福島県,7423,柳津町'
muni['7444'] = '7,福島県,7444,三島町'
muni['7445'] = '7,福島県,7445,金山町'
muni['7446'] = '7,福島県,7446,昭和村'
muni['7447'] = '7,福島県,7447,会津美里町'
muni['7461'] = '7,福島県,7461,西郷村'
muni['7464'] = '7,福島県,7464,泉崎村'
muni['7465'] = '7,福島県,7465,中島村'
muni['7466'] = '7,福島県,7466,矢吹町'
muni['7481'] = '7,福島県,7481,棚倉町'
muni['7482'] = '7,福島県,7482,矢祭町'
muni['7483'] = '7,福島県,7483,塙町'
muni['7484'] = '7,福島県,7484,鮫川村'
muni['7501'] = '7,福島県,7501,石川町'
muni['7502'] = '7,福島県,7502,玉川村'
muni['7503'] = '7,福島県,7503,平田村'
muni['7504'] = '7,福島県,7504,浅川町'
muni['7505'] = '7,福島県,7505,古殿町'
muni['7521'] = '7,福島県,7521,三春町'
muni['7522'] = '7,福島県,7522,小野町'
muni['7541'] = '7,福島県,7541,広野町'
muni['7542'] = '7,福島県,7542,楢葉町'
muni['7543'] = '7,福島県,7543,富岡町'
muni['7544'] = '7,福島県,7544,川内村'
muni['7545'] = '7,福島県,7545,大熊町'
muni['7546'] = '7,福島県,7546,双葉町'
muni['7547'] = '7,福島県,7547,浪江町'
muni['7548'] = '7,福島県,7548,葛尾村'
muni['7561'] = '7,福島県,7561,新地町'
muni['7564'] = '7,福島県,7564,飯舘村'
muni['8201'] = '8,茨城県,8201,水戸市'
muni['8202'] = '8,茨城県,8202,日立市'
muni['8203'] = '8,茨城県,8203,土浦市'
muni['8204'] = '8,茨城県,8204,古河市'
muni['8205'] = '8,茨城県,8205,石岡市'
muni['8207'] = '8,茨城県,8207,結城市'
muni['8208'] = '8,茨城県,8208,龍ケ崎市'
muni['8210'] = '8,茨城県,8210,下妻市'
muni['8211'] = '8,茨城県,8211,常総市'
muni['8212'] = '8,茨城県,8212,常陸太田市'
muni['8214'] = '8,茨城県,8214,高萩市'
muni['8215'] = '8,茨城県,8215,北茨城市'
muni['8216'] = '8,茨城県,8216,笠間市'
muni['8217'] = '8,茨城県,8217,取手市'
muni['8219'] = '8,茨城県,8219,牛久市'
muni['8220'] = '8,茨城県,8220,つくば市'
muni['8221'] = '8,茨城県,8221,ひたちなか市'
muni['8222'] = '8,茨城県,8222,鹿嶋市'
muni['8223'] = '8,茨城県,8223,潮来市'
muni['8224'] = '8,茨城県,8224,守谷市'
muni['8225'] = '8,茨城県,8225,常陸大宮市'
muni['8226'] = '8,茨城県,8226,那珂市'
muni['8227'] = '8,茨城県,8227,筑西市'
muni['8228'] = '8,茨城県,8228,坂東市'
muni['8229'] = '8,茨城県,8229,稲敷市'
muni['8230'] = '8,茨城県,8230,かすみがうら市'
muni['8231'] = '8,茨城県,8231,桜川市'
muni['8232'] = '8,茨城県,8232,神栖市'
muni['8233'] = '8,茨城県,8233,行方市'
muni['8234'] = '8,茨城県,8234,鉾田市'
muni['8235'] = '8,茨城県,8235,つくばみらい市'
muni['8236'] = '8,茨城県,8236,小美玉市'
muni['8302'] = '8,茨城県,8302,茨城町'
muni['8309'] = '8,茨城県,8309,大洗町'
muni['8310'] = '8,茨城県,8310,城里町'
muni['8341'] = '8,茨城県,8341,東海村'
muni['8364'] = '8,茨城県,8364,大子町'
muni['8442'] = '8,茨城県,8442,美浦村'
muni['8443'] = '8,茨城県,8443,阿見町'
muni['8447'] = '8,茨城県,8447,河内町'
muni['8521'] = '8,茨城県,8521,八千代町'
muni['8542'] = '8,茨城県,8542,五霞町'
muni['8546'] = '8,茨城県,8546,境町'
muni['8564'] = '8,茨城県,8564,利根町'
muni['9201'] = '9,栃木県,9201,宇都宮市'
muni['9202'] = '9,栃木県,9202,足利市'
muni['9203'] = '9,栃木県,9203,栃木市'
muni['9204'] = '9,栃木県,9204,佐野市'
muni['9205'] = '9,栃木県,9205,鹿沼市'
muni['9206'] = '9,栃木県,9206,日光市'
muni['9208'] = '9,栃木県,9208,小山市'
muni['9209'] = '9,栃木県,9209,真岡市'
muni['9210'] = '9,栃木県,9210,大田原市'
muni['9211'] = '9,栃木県,9211,矢板市'
muni['9213'] = '9,栃木県,9213,那須塩原市'
muni['9214'] = '9,栃木県,9214,さくら市'
muni['9215'] = '9,栃木県,9215,那須烏山市'
muni['9216'] = '9,栃木県,9216,下野市'
muni['9301'] = '9,栃木県,9301,上三川町'
muni['9342'] = '9,栃木県,9342,益子町'
muni['9343'] = '9,栃木県,9343,茂木町'
muni['9344'] = '9,栃木県,9344,市貝町'
muni['9345'] = '9,栃木県,9345,芳賀町'
muni['9361'] = '9,栃木県,9361,壬生町'
muni['9364'] = '9,栃木県,9364,野木町'
muni['9384'] = '9,栃木県,9384,塩谷町'
muni['9386'] = '9,栃木県,9386,高根沢町'
muni['9407'] = '9,栃木県,9407,那須町'
muni['9411'] = '9,栃木県,9411,那珂川町'
muni['10201'] = '10,群馬県,10201,前橋市'
muni['10202'] = '10,群馬県,10202,高崎市'
muni['10203'] = '10,群馬県,10203,桐生市'
muni['10204'] = '10,群馬県,10204,伊勢崎市'
muni['10205'] = '10,群馬県,10205,太田市'
muni['10206'] = '10,群馬県,10206,沼田市'
muni['10207'] = '10,群馬県,10207,館林市'
muni['10208'] = '10,群馬県,10208,渋川市'
muni['10209'] = '10,群馬県,10209,藤岡市'
muni['10210'] = '10,群馬県,10210,富岡市'
muni['10211'] = '10,群馬県,10211,安中市'
muni['10212'] = '10,群馬県,10212,みどり市'
muni['10344'] = '10,群馬県,10344,榛東村'
muni['10345'] = '10,群馬県,10345,吉岡町'
muni['10366'] = '10,群馬県,10366,上野村'
muni['10367'] = '10,群馬県,10367,神流町'
muni['10382'] = '10,群馬県,10382,下仁田町'
muni['10383'] = '10,群馬県,10383,南牧村'
muni['10384'] = '10,群馬県,10384,甘楽町'
muni['10421'] = '10,群馬県,10421,中之条町'
muni['10424'] = '10,群馬県,10424,長野原町'
muni['10425'] = '10,群馬県,10425,嬬恋村'
muni['10426'] = '10,群馬県,10426,草津町'
muni['10428'] = '10,群馬県,10428,高山村'
muni['10429'] = '10,群馬県,10429,東吾妻町'
muni['10443'] = '10,群馬県,10443,片品村'
muni['10444'] = '10,群馬県,10444,川場村'
muni['10448'] = '10,群馬県,10448,昭和村'
muni['10449'] = '10,群馬県,10449,みなかみ町'
muni['10464'] = '10,群馬県,10464,玉村町'
muni['10521'] = '10,群馬県,10521,板倉町'
muni['10522'] = '10,群馬県,10522,明和町'
muni['10523'] = '10,群馬県,10523,千代田町'
muni['10524'] = '10,群馬県,10524,大泉町'
muni['10525'] = '10,群馬県,10525,邑楽町'
muni['11100'] = '11,埼玉県,11100,さいたま市'
muni['11101'] = '11,埼玉県,11101,さいたま市　西区'
muni['11102'] = '11,埼玉県,11102,さいたま市　北区'
muni['11103'] = '11,埼玉県,11103,さいたま市　大宮区'
muni['11104'] = '11,埼玉県,11104,さいたま市　見沼区'
muni['11105'] = '11,埼玉県,11105,さいたま市　中央区'
muni['11106'] = '11,埼玉県,11106,さいたま市　桜区'
muni['11107'] = '11,埼玉県,11107,さいたま市　浦和区'
muni['11108'] = '11,埼玉県,11108,さいたま市　南区'
muni['11109'] = '11,埼玉県,11109,さいたま市　緑区'
muni['11110'] = '11,埼玉県,11110,さいたま市　岩槻区'
muni['11201'] = '11,埼玉県,11201,川越市'
muni['11202'] = '11,埼玉県,11202,熊谷市'
muni['11203'] = '11,埼玉県,11203,川口市'
muni['11206'] = '11,埼玉県,11206,行田市'
muni['11207'] = '11,埼玉県,11207,秩父市'
muni['11208'] = '11,埼玉県,11208,所沢市'
muni['11209'] = '11,埼玉県,11209,飯能市'
muni['11210'] = '11,埼玉県,11210,加須市'
muni['11211'] = '11,埼玉県,11211,本庄市'
muni['11212'] = '11,埼玉県,11212,東松山市'
muni['11214'] = '11,埼玉県,11214,春日部市'
muni['11215'] = '11,埼玉県,11215,狭山市'
muni['11216'] = '11,埼玉県,11216,羽生市'
muni['11217'] = '11,埼玉県,11217,鴻巣市'
muni['11218'] = '11,埼玉県,11218,深谷市'
muni['11219'] = '11,埼玉県,11219,上尾市'
muni['11221'] = '11,埼玉県,11221,草加市'
muni['11222'] = '11,埼玉県,11222,越谷市'
muni['11223'] = '11,埼玉県,11223,蕨市'
muni['11224'] = '11,埼玉県,11224,戸田市'
muni['11225'] = '11,埼玉県,11225,入間市'
muni['11227'] = '11,埼玉県,11227,朝霞市'
muni['11228'] = '11,埼玉県,11228,志木市'
muni['11229'] = '11,埼玉県,11229,和光市'
muni['11230'] = '11,埼玉県,11230,新座市'
muni['11231'] = '11,埼玉県,11231,桶川市'
muni['11232'] = '11,埼玉県,11232,久喜市'
muni['11233'] = '11,埼玉県,11233,北本市'
muni['11234'] = '11,埼玉県,11234,八潮市'
muni['11235'] = '11,埼玉県,11235,富士見市'
muni['11237'] = '11,埼玉県,11237,三郷市'
muni['11238'] = '11,埼玉県,11238,蓮田市'
muni['11239'] = '11,埼玉県,11239,坂戸市'
muni['11240'] = '11,埼玉県,11240,幸手市'
muni['11241'] = '11,埼玉県,11241,鶴ヶ島市'
muni['11242'] = '11,埼玉県,11242,日高市'
muni['11243'] = '11,埼玉県,11243,吉川市'
muni['11245'] = '11,埼玉県,11245,ふじみ野市'
muni['11301'] = '11,埼玉県,11301,伊奈町'
muni['11324'] = '11,埼玉県,11324,三芳町'
muni['11326'] = '11,埼玉県,11326,毛呂山町'
muni['11327'] = '11,埼玉県,11327,越生町'
muni['11341'] = '11,埼玉県,11341,滑川町'
muni['11342'] = '11,埼玉県,11342,嵐山町'
muni['11343'] = '11,埼玉県,11343,小川町'
muni['11346'] = '11,埼玉県,11346,川島町'
muni['11347'] = '11,埼玉県,11347,吉見町'
muni['11348'] = '11,埼玉県,11348,鳩山町'
muni['11349'] = '11,埼玉県,11349,ときがわ町'
muni['11361'] = '11,埼玉県,11361,横瀬町'
muni['11362'] = '11,埼玉県,11362,皆野町'
muni['11363'] = '11,埼玉県,11363,長瀞町'
muni['11365'] = '11,埼玉県,11365,小鹿野町'
muni['11369'] = '11,埼玉県,11369,東秩父村'
muni['11381'] = '11,埼玉県,11381,美里町'
muni['11383'] = '11,埼玉県,11383,神川町'
muni['11385'] = '11,埼玉県,11385,上里町'
muni['11408'] = '11,埼玉県,11408,寄居町'
muni['11442'] = '11,埼玉県,11442,宮代町'
muni['11246'] = '11,埼玉県,11246,白岡市'
muni['11464'] = '11,埼玉県,11464,杉戸町'
muni['11465'] = '11,埼玉県,11465,松伏町'
muni['12100'] = '12,千葉県,12100,千葉市'
muni['12101'] = '12,千葉県,12101,千葉市　中央区'
muni['12102'] = '12,千葉県,12102,千葉市　花見川区'
muni['12103'] = '12,千葉県,12103,千葉市　稲毛区'
muni['12104'] = '12,千葉県,12104,千葉市　若葉区'
muni['12105'] = '12,千葉県,12105,千葉市　緑区'
muni['12106'] = '12,千葉県,12106,千葉市　美浜区'
muni['12202'] = '12,千葉県,12202,銚子市'
muni['12203'] = '12,千葉県,12203,市川市'
muni['12204'] = '12,千葉県,12204,船橋市'
muni['12205'] = '12,千葉県,12205,館山市'
muni['12206'] = '12,千葉県,12206,木更津市'
muni['12207'] = '12,千葉県,12207,松戸市'
muni['12208'] = '12,千葉県,12208,野田市'
muni['12210'] = '12,千葉県,12210,茂原市'
muni['12211'] = '12,千葉県,12211,成田市'
muni['12212'] = '12,千葉県,12212,佐倉市'
muni['12213'] = '12,千葉県,12213,東金市'
muni['12215'] = '12,千葉県,12215,旭市'
muni['12216'] = '12,千葉県,12216,習志野市'
muni['12217'] = '12,千葉県,12217,柏市'
muni['12218'] = '12,千葉県,12218,勝浦市'
muni['12219'] = '12,千葉県,12219,市原市'
muni['12220'] = '12,千葉県,12220,流山市'
muni['12221'] = '12,千葉県,12221,八千代市'
muni['12222'] = '12,千葉県,12222,我孫子市'
muni['12223'] = '12,千葉県,12223,鴨川市'
muni['12224'] = '12,千葉県,12224,鎌ケ谷市'
muni['12225'] = '12,千葉県,12225,君津市'
muni['12226'] = '12,千葉県,12226,富津市'
muni['12227'] = '12,千葉県,12227,浦安市'
muni['12228'] = '12,千葉県,12228,四街道市'
muni['12229'] = '12,千葉県,12229,袖ケ浦市'
muni['12230'] = '12,千葉県,12230,八街市'
muni['12231'] = '12,千葉県,12231,印西市'
muni['12232'] = '12,千葉県,12232,白井市'
muni['12233'] = '12,千葉県,12233,富里市'
muni['12234'] = '12,千葉県,12234,南房総市'
muni['12235'] = '12,千葉県,12235,匝瑳市'
muni['12236'] = '12,千葉県,12236,香取市'
muni['12237'] = '12,千葉県,12237,山武市'
muni['12238'] = '12,千葉県,12238,いすみ市'
muni['12322'] = '12,千葉県,12322,酒々井町'
muni['12329'] = '12,千葉県,12329,栄町'
muni['12342'] = '12,千葉県,12342,神崎町'
muni['12347'] = '12,千葉県,12347,多古町'
muni['12349'] = '12,千葉県,12349,東庄町'
muni['12239'] = '12,千葉県,12239,大網白里市'
muni['12403'] = '12,千葉県,12403,九十九里町'
muni['12409'] = '12,千葉県,12409,芝山町'
muni['12410'] = '12,千葉県,12410,横芝光町'
muni['12421'] = '12,千葉県,12421,一宮町'
muni['12422'] = '12,千葉県,12422,睦沢町'
muni['12423'] = '12,千葉県,12423,長生村'
muni['12424'] = '12,千葉県,12424,白子町'
muni['12426'] = '12,千葉県,12426,長柄町'
muni['12427'] = '12,千葉県,12427,長南町'
muni['12441'] = '12,千葉県,12441,大多喜町'
muni['12443'] = '12,千葉県,12443,御宿町'
muni['12463'] = '12,千葉県,12463,鋸南町'
muni['13100'] = '13,東京都,13100,23区'
muni['13101'] = '13,東京都,13101,千代田区'
muni['13102'] = '13,東京都,13102,中央区'
muni['13103'] = '13,東京都,13103,港区'
muni['13104'] = '13,東京都,13104,新宿区'
muni['13105'] = '13,東京都,13105,文京区'
muni['13106'] = '13,東京都,13106,台東区'
muni['13107'] = '13,東京都,13107,墨田区'
muni['13108'] = '13,東京都,13108,江東区'
muni['13109'] = '13,東京都,13109,品川区'
muni['13110'] = '13,東京都,13110,目黒区'
muni['13111'] = '13,東京都,13111,大田区'
muni['13112'] = '13,東京都,13112,世田谷区'
muni['13113'] = '13,東京都,13113,渋谷区'
muni['13114'] = '13,東京都,13114,中野区'
muni['13115'] = '13,東京都,13115,杉並区'
muni['13116'] = '13,東京都,13116,豊島区'
muni['13117'] = '13,東京都,13117,北区'
muni['13118'] = '13,東京都,13118,荒川区'
muni['13119'] = '13,東京都,13119,板橋区'
muni['13120'] = '13,東京都,13120,練馬区'
muni['13121'] = '13,東京都,13121,足立区'
muni['13122'] = '13,東京都,13122,葛飾区'
muni['13123'] = '13,東京都,13123,江戸川区'
muni['13201'] = '13,東京都,13201,八王子市'
muni['13202'] = '13,東京都,13202,立川市'
muni['13203'] = '13,東京都,13203,武蔵野市'
muni['13204'] = '13,東京都,13204,三鷹市'
muni['13205'] = '13,東京都,13205,青梅市'
muni['13206'] = '13,東京都,13206,府中市'
muni['13207'] = '13,東京都,13207,昭島市'
muni['13208'] = '13,東京都,13208,調布市'
muni['13209'] = '13,東京都,13209,町田市'
muni['13210'] = '13,東京都,13210,小金井市'
muni['13211'] = '13,東京都,13211,小平市'
muni['13212'] = '13,東京都,13212,日野市'
muni['13213'] = '13,東京都,13213,東村山市'
muni['13214'] = '13,東京都,13214,国分寺市'
muni['13215'] = '13,東京都,13215,国立市'
muni['13218'] = '13,東京都,13218,福生市'
muni['13219'] = '13,東京都,13219,狛江市'
muni['13220'] = '13,東京都,13220,東大和市'
muni['13221'] = '13,東京都,13221,清瀬市'
muni['13222'] = '13,東京都,13222,東久留米市'
muni['13223'] = '13,東京都,13223,武蔵村山市'
muni['13224'] = '13,東京都,13224,多摩市'
muni['13225'] = '13,東京都,13225,稲城市'
muni['13227'] = '13,東京都,13227,羽村市'
muni['13228'] = '13,東京都,13228,あきる野市'
muni['13229'] = '13,東京都,13229,西東京市'
muni['13303'] = '13,東京都,13303,瑞穂町'
muni['13305'] = '13,東京都,13305,日の出町'
muni['13307'] = '13,東京都,13307,檜原村'
muni['13308'] = '13,東京都,13308,奥多摩町'
muni['13361'] = '13,東京都,13361,大島町'
muni['13362'] = '13,東京都,13362,利島村'
muni['13363'] = '13,東京都,13363,新島村'
muni['13364'] = '13,東京都,13364,神津島村'
muni['13381'] = '13,東京都,13381,三宅村'
muni['13382'] = '13,東京都,13382,御蔵島村'
muni['13401'] = '13,東京都,13401,八丈町'
muni['13402'] = '13,東京都,13402,青ヶ島村'
muni['13421'] = '13,東京都,13421,小笠原村'
muni['14100'] = '14,神奈川県,14100,横浜市'
muni['14101'] = '14,神奈川県,14101,横浜市　鶴見区'
muni['14102'] = '14,神奈川県,14102,横浜市　神奈川区'
muni['14103'] = '14,神奈川県,14103,横浜市　西区'
muni['14104'] = '14,神奈川県,14104,横浜市　中区'
muni['14105'] = '14,神奈川県,14105,横浜市　南区'
muni['14106'] = '14,神奈川県,14106,横浜市　保土ケ谷区'
muni['14107'] = '14,神奈川県,14107,横浜市　磯子区'
muni['14108'] = '14,神奈川県,14108,横浜市　金沢区'
muni['14109'] = '14,神奈川県,14109,横浜市　港北区'
muni['14110'] = '14,神奈川県,14110,横浜市　戸塚区'
muni['14111'] = '14,神奈川県,14111,横浜市　港南区'
muni['14112'] = '14,神奈川県,14112,横浜市　旭区'
muni['14113'] = '14,神奈川県,14113,横浜市　緑区'
muni['14114'] = '14,神奈川県,14114,横浜市　瀬谷区'
muni['14115'] = '14,神奈川県,14115,横浜市　栄区'
muni['14116'] = '14,神奈川県,14116,横浜市　泉区'
muni['14117'] = '14,神奈川県,14117,横浜市　青葉区'
muni['14118'] = '14,神奈川県,14118,横浜市　都筑区'
muni['14130'] = '14,神奈川県,14130,川崎市'
muni['14131'] = '14,神奈川県,14131,川崎市　川崎区'
muni['14132'] = '14,神奈川県,14132,川崎市　幸区'
muni['14133'] = '14,神奈川県,14133,川崎市　中原区'
muni['14134'] = '14,神奈川県,14134,川崎市　高津区'
muni['14135'] = '14,神奈川県,14135,川崎市　多摩区'
muni['14136'] = '14,神奈川県,14136,川崎市　宮前区'
muni['14137'] = '14,神奈川県,14137,川崎市　麻生区'
muni['14150'] = '14,神奈川県,14150,相模原市'
muni['14151'] = '14,神奈川県,14151,相模原市　緑区'
muni['14152'] = '14,神奈川県,14152,相模原市　中央区'
muni['14153'] = '14,神奈川県,14153,相模原市　南区'
muni['14201'] = '14,神奈川県,14201,横須賀市'
muni['14203'] = '14,神奈川県,14203,平塚市'
muni['14204'] = '14,神奈川県,14204,鎌倉市'
muni['14205'] = '14,神奈川県,14205,藤沢市'
muni['14206'] = '14,神奈川県,14206,小田原市'
muni['14207'] = '14,神奈川県,14207,茅ヶ崎市'
muni['14208'] = '14,神奈川県,14208,逗子市'
muni['14210'] = '14,神奈川県,14210,三浦市'
muni['14211'] = '14,神奈川県,14211,秦野市'
muni['14212'] = '14,神奈川県,14212,厚木市'
muni['14213'] = '14,神奈川県,14213,大和市'
muni['14214'] = '14,神奈川県,14214,伊勢原市'
muni['14215'] = '14,神奈川県,14215,海老名市'
muni['14216'] = '14,神奈川県,14216,座間市'
muni['14217'] = '14,神奈川県,14217,南足柄市'
muni['14218'] = '14,神奈川県,14218,綾瀬市'
muni['14301'] = '14,神奈川県,14301,葉山町'
muni['14321'] = '14,神奈川県,14321,寒川町'
muni['14341'] = '14,神奈川県,14341,大磯町'
muni['14342'] = '14,神奈川県,14342,二宮町'
muni['14361'] = '14,神奈川県,14361,中井町'
muni['14362'] = '14,神奈川県,14362,大井町'
muni['14363'] = '14,神奈川県,14363,松田町'
muni['14364'] = '14,神奈川県,14364,山北町'
muni['14366'] = '14,神奈川県,14366,開成町'
muni['14382'] = '14,神奈川県,14382,箱根町'
muni['14383'] = '14,神奈川県,14383,真鶴町'
muni['14384'] = '14,神奈川県,14384,湯河原町'
muni['14401'] = '14,神奈川県,14401,愛川町'
muni['14402'] = '14,神奈川県,14402,清川村'
muni['15100'] = '15,新潟県,15100,新潟市'
muni['15101'] = '15,新潟県,15101,新潟市　北区'
muni['15102'] = '15,新潟県,15102,新潟市　東区'
muni['15103'] = '15,新潟県,15103,新潟市　中央区'
muni['15104'] = '15,新潟県,15104,新潟市　江南区'
muni['15105'] = '15,新潟県,15105,新潟市　秋葉区'
muni['15106'] = '15,新潟県,15106,新潟市　南区'
muni['15107'] = '15,新潟県,15107,新潟市　西区'
muni['15108'] = '15,新潟県,15108,新潟市　西蒲区'
muni['15202'] = '15,新潟県,15202,長岡市'
muni['15204'] = '15,新潟県,15204,三条市'
muni['15205'] = '15,新潟県,15205,柏崎市'
muni['15206'] = '15,新潟県,15206,新発田市'
muni['15208'] = '15,新潟県,15208,小千谷市'
muni['15209'] = '15,新潟県,15209,加茂市'
muni['15210'] = '15,新潟県,15210,十日町市'
muni['15211'] = '15,新潟県,15211,見附市'
muni['15212'] = '15,新潟県,15212,村上市'
muni['15213'] = '15,新潟県,15213,燕市'
muni['15216'] = '15,新潟県,15216,糸魚川市'
muni['15217'] = '15,新潟県,15217,妙高市'
muni['15218'] = '15,新潟県,15218,五泉市'
muni['15222'] = '15,新潟県,15222,上越市'
muni['15223'] = '15,新潟県,15223,阿賀野市'
muni['15224'] = '15,新潟県,15224,佐渡市'
muni['15225'] = '15,新潟県,15225,魚沼市'
muni['15226'] = '15,新潟県,15226,南魚沼市'
muni['15227'] = '15,新潟県,15227,胎内市'
muni['15307'] = '15,新潟県,15307,聖籠町'
muni['15342'] = '15,新潟県,15342,弥彦村'
muni['15361'] = '15,新潟県,15361,田上町'
muni['15385'] = '15,新潟県,15385,阿賀町'
muni['15405'] = '15,新潟県,15405,出雲崎町'
muni['15461'] = '15,新潟県,15461,湯沢町'
muni['15482'] = '15,新潟県,15482,津南町'
muni['15504'] = '15,新潟県,15504,刈羽村'
muni['15581'] = '15,新潟県,15581,関川村'
muni['15586'] = '15,新潟県,15586,粟島浦村'
muni['16201'] = '16,富山県,16201,富山市'
muni['16202'] = '16,富山県,16202,高岡市'
muni['16204'] = '16,富山県,16204,魚津市'
muni['16205'] = '16,富山県,16205,氷見市'
muni['16206'] = '16,富山県,16206,滑川市'
muni['16207'] = '16,富山県,16207,黒部市'
muni['16208'] = '16,富山県,16208,砺波市'
muni['16209'] = '16,富山県,16209,小矢部市'
muni['16210'] = '16,富山県,16210,南砺市'
muni['16211'] = '16,富山県,16211,射水市'
muni['16321'] = '16,富山県,16321,舟橋村'
muni['16322'] = '16,富山県,16322,上市町'
muni['16323'] = '16,富山県,16323,立山町'
muni['16342'] = '16,富山県,16342,入善町'
muni['16343'] = '16,富山県,16343,朝日町'
muni['17201'] = '17,石川県,17201,金沢市'
muni['17202'] = '17,石川県,17202,七尾市'
muni['17203'] = '17,石川県,17203,小松市'
muni['17204'] = '17,石川県,17204,輪島市'
muni['17205'] = '17,石川県,17205,珠洲市'
muni['17206'] = '17,石川県,17206,加賀市'
muni['17207'] = '17,石川県,17207,羽咋市'
muni['17209'] = '17,石川県,17209,かほく市'
muni['17210'] = '17,石川県,17210,白山市'
muni['17211'] = '17,石川県,17211,能美市'
muni['17212'] = '17,石川県,17212,野々市市'
muni['17324'] = '17,石川県,17324,川北町'
muni['17361'] = '17,石川県,17361,津幡町'
muni['17365'] = '17,石川県,17365,内灘町'
muni['17384'] = '17,石川県,17384,志賀町'
muni['17386'] = '17,石川県,17386,宝達志水町'
muni['17407'] = '17,石川県,17407,中能登町'
muni['17461'] = '17,石川県,17461,穴水町'
muni['17463'] = '17,石川県,17463,能登町'
muni['18201'] = '18,福井県,18201,福井市'
muni['18202'] = '18,福井県,18202,敦賀市'
muni['18204'] = '18,福井県,18204,小浜市'
muni['18205'] = '18,福井県,18205,大野市'
muni['18206'] = '18,福井県,18206,勝山市'
muni['18207'] = '18,福井県,18207,鯖江市'
muni['18208'] = '18,福井県,18208,あわら市'
muni['18209'] = '18,福井県,18209,越前市'
muni['18210'] = '18,福井県,18210,坂井市'
muni['18322'] = '18,福井県,18322,永平寺町'
muni['18382'] = '18,福井県,18382,池田町'
muni['18404'] = '18,福井県,18404,南越前町'
muni['18423'] = '18,福井県,18423,越前町'
muni['18442'] = '18,福井県,18442,美浜町'
muni['18481'] = '18,福井県,18481,高浜町'
muni['18483'] = '18,福井県,18483,おおい町'
muni['18501'] = '18,福井県,18501,若狭町'
muni['19201'] = '19,山梨県,19201,甲府市'
muni['19202'] = '19,山梨県,19202,富士吉田市'
muni['19204'] = '19,山梨県,19204,都留市'
muni['19205'] = '19,山梨県,19205,山梨市'
muni['19206'] = '19,山梨県,19206,大月市'
muni['19207'] = '19,山梨県,19207,韮崎市'
muni['19208'] = '19,山梨県,19208,南アルプス市'
muni['19209'] = '19,山梨県,19209,北杜市'
muni['19210'] = '19,山梨県,19210,甲斐市'
muni['19211'] = '19,山梨県,19211,笛吹市'
muni['19212'] = '19,山梨県,19212,上野原市'
muni['19213'] = '19,山梨県,19213,甲州市'
muni['19214'] = '19,山梨県,19214,中央市'
muni['19346'] = '19,山梨県,19346,市川三郷町'
muni['19364'] = '19,山梨県,19364,早川町'
muni['19365'] = '19,山梨県,19365,身延町'
muni['19366'] = '19,山梨県,19366,南部町'
muni['19368'] = '19,山梨県,19368,富士川町'
muni['19384'] = '19,山梨県,19384,昭和町'
muni['19422'] = '19,山梨県,19422,道志村'
muni['19423'] = '19,山梨県,19423,西桂町'
muni['19424'] = '19,山梨県,19424,忍野村'
muni['19425'] = '19,山梨県,19425,山中湖村'
muni['19429'] = '19,山梨県,19429,鳴沢村'
muni['19430'] = '19,山梨県,19430,富士河口湖町'
muni['19442'] = '19,山梨県,19442,小菅村'
muni['19443'] = '19,山梨県,19443,丹波山村'
muni['20201'] = '20,長野県,20201,長野市'
muni['20202'] = '20,長野県,20202,松本市'
muni['20203'] = '20,長野県,20203,上田市'
muni['20204'] = '20,長野県,20204,岡谷市'
muni['20205'] = '20,長野県,20205,飯田市'
muni['20206'] = '20,長野県,20206,諏訪市'
muni['20207'] = '20,長野県,20207,須坂市'
muni['20208'] = '20,長野県,20208,小諸市'
muni['20209'] = '20,長野県,20209,伊那市'
muni['20210'] = '20,長野県,20210,駒ヶ根市'
muni['20211'] = '20,長野県,20211,中野市'
muni['20212'] = '20,長野県,20212,大町市'
muni['20213'] = '20,長野県,20213,飯山市'
muni['20214'] = '20,長野県,20214,茅野市'
muni['20215'] = '20,長野県,20215,塩尻市'
muni['20217'] = '20,長野県,20217,佐久市'
muni['20218'] = '20,長野県,20218,千曲市'
muni['20219'] = '20,長野県,20219,東御市'
muni['20220'] = '20,長野県,20220,安曇野市'
muni['20303'] = '20,長野県,20303,小海町'
muni['20304'] = '20,長野県,20304,川上村'
muni['20305'] = '20,長野県,20305,南牧村'
muni['20306'] = '20,長野県,20306,南相木村'
muni['20307'] = '20,長野県,20307,北相木村'
muni['20309'] = '20,長野県,20309,佐久穂町'
muni['20321'] = '20,長野県,20321,軽井沢町'
muni['20323'] = '20,長野県,20323,御代田町'
muni['20324'] = '20,長野県,20324,立科町'
muni['20349'] = '20,長野県,20349,青木村'
muni['20350'] = '20,長野県,20350,長和町'
muni['20361'] = '20,長野県,20361,下諏訪町'
muni['20362'] = '20,長野県,20362,富士見町'
muni['20363'] = '20,長野県,20363,原村'
muni['20382'] = '20,長野県,20382,辰野町'
muni['20383'] = '20,長野県,20383,箕輪町'
muni['20384'] = '20,長野県,20384,飯島町'
muni['20385'] = '20,長野県,20385,南箕輪村'
muni['20386'] = '20,長野県,20386,中川村'
muni['20388'] = '20,長野県,20388,宮田村'
muni['20402'] = '20,長野県,20402,松川町'
muni['20403'] = '20,長野県,20403,高森町'
muni['20404'] = '20,長野県,20404,阿南町'
muni['20407'] = '20,長野県,20407,阿智村'
muni['20409'] = '20,長野県,20409,平谷村'
muni['20410'] = '20,長野県,20410,根羽村'
muni['20411'] = '20,長野県,20411,下條村'
muni['20412'] = '20,長野県,20412,売木村'
muni['20413'] = '20,長野県,20413,天龍村'
muni['20414'] = '20,長野県,20414,泰阜村'
muni['20415'] = '20,長野県,20415,喬木村'
muni['20416'] = '20,長野県,20416,豊丘村'
muni['20417'] = '20,長野県,20417,大鹿村'
muni['20422'] = '20,長野県,20422,上松町'
muni['20423'] = '20,長野県,20423,南木曽町'
muni['20425'] = '20,長野県,20425,木祖村'
muni['20429'] = '20,長野県,20429,王滝村'
muni['20430'] = '20,長野県,20430,大桑村'
muni['20432'] = '20,長野県,20432,木曽町'
muni['20446'] = '20,長野県,20446,麻績村'
muni['20448'] = '20,長野県,20448,生坂村'
muni['20450'] = '20,長野県,20450,山形村'
muni['20451'] = '20,長野県,20451,朝日村'
muni['20452'] = '20,長野県,20452,筑北村'
muni['20481'] = '20,長野県,20481,池田町'
muni['20482'] = '20,長野県,20482,松川村'
muni['20485'] = '20,長野県,20485,白馬村'
muni['20486'] = '20,長野県,20486,小谷村'
muni['20521'] = '20,長野県,20521,坂城町'
muni['20541'] = '20,長野県,20541,小布施町'
muni['20543'] = '20,長野県,20543,高山村'
muni['20561'] = '20,長野県,20561,山ノ内町'
muni['20562'] = '20,長野県,20562,木島平村'
muni['20563'] = '20,長野県,20563,野沢温泉村'
muni['20583'] = '20,長野県,20583,信濃町'
muni['20588'] = '20,長野県,20588,小川村'
muni['20590'] = '20,長野県,20590,飯綱町'
muni['20602'] = '20,長野県,20602,栄村'
muni['21201'] = '21,岐阜県,21201,岐阜市'
muni['21202'] = '21,岐阜県,21202,大垣市'
muni['21203'] = '21,岐阜県,21203,高山市'
muni['21204'] = '21,岐阜県,21204,多治見市'
muni['21205'] = '21,岐阜県,21205,関市'
muni['21206'] = '21,岐阜県,21206,中津川市'
muni['21207'] = '21,岐阜県,21207,美濃市'
muni['21208'] = '21,岐阜県,21208,瑞浪市'
muni['21209'] = '21,岐阜県,21209,羽島市'
muni['21210'] = '21,岐阜県,21210,恵那市'
muni['21211'] = '21,岐阜県,21211,美濃加茂市'
muni['21212'] = '21,岐阜県,21212,土岐市'
muni['21213'] = '21,岐阜県,21213,各務原市'
muni['21214'] = '21,岐阜県,21214,可児市'
muni['21215'] = '21,岐阜県,21215,山県市'
muni['21216'] = '21,岐阜県,21216,瑞穂市'
muni['21217'] = '21,岐阜県,21217,飛騨市'
muni['21218'] = '21,岐阜県,21218,本巣市'
muni['21219'] = '21,岐阜県,21219,郡上市'
muni['21220'] = '21,岐阜県,21220,下呂市'
muni['21221'] = '21,岐阜県,21221,海津市'
muni['21302'] = '21,岐阜県,21302,岐南町'
muni['21303'] = '21,岐阜県,21303,笠松町'
muni['21341'] = '21,岐阜県,21341,養老町'
muni['21361'] = '21,岐阜県,21361,垂井町'
muni['21362'] = '21,岐阜県,21362,関ケ原町'
muni['21381'] = '21,岐阜県,21381,神戸町'
muni['21382'] = '21,岐阜県,21382,輪之内町'
muni['21383'] = '21,岐阜県,21383,安八町'
muni['21401'] = '21,岐阜県,21401,揖斐川町'
muni['21403'] = '21,岐阜県,21403,大野町'
muni['21404'] = '21,岐阜県,21404,池田町'
muni['21421'] = '21,岐阜県,21421,北方町'
muni['21501'] = '21,岐阜県,21501,坂祝町'
muni['21502'] = '21,岐阜県,21502,富加町'
muni['21503'] = '21,岐阜県,21503,川辺町'
muni['21504'] = '21,岐阜県,21504,七宗町'
muni['21505'] = '21,岐阜県,21505,八百津町'
muni['21506'] = '21,岐阜県,21506,白川町'
muni['21507'] = '21,岐阜県,21507,東白川村'
muni['21521'] = '21,岐阜県,21521,御嵩町'
muni['21604'] = '21,岐阜県,21604,白川村'
muni['22100'] = '22,静岡県,22100,静岡市'
muni['22101'] = '22,静岡県,22101,静岡市　葵区'
muni['22102'] = '22,静岡県,22102,静岡市　駿河区'
muni['22103'] = '22,静岡県,22103,静岡市　清水区'
muni['22130'] = '22,静岡県,22130,浜松市'
muni['22138'] = '22,静岡県,22138,浜松市　中央区'
muni['22139'] = '22,静岡県,22139,浜松市　浜名区'
muni['22140'] = '22,静岡県,22140,浜松市　天竜区'
muni['22203'] = '22,静岡県,22203,沼津市'
muni['22205'] = '22,静岡県,22205,熱海市'
muni['22206'] = '22,静岡県,22206,三島市'
muni['22207'] = '22,静岡県,22207,富士宮市'
muni['22208'] = '22,静岡県,22208,伊東市'
muni['22209'] = '22,静岡県,22209,島田市'
muni['22210'] = '22,静岡県,22210,富士市'
muni['22211'] = '22,静岡県,22211,磐田市'
muni['22212'] = '22,静岡県,22212,焼津市'
muni['22213'] = '22,静岡県,22213,掛川市'
muni['22214'] = '22,静岡県,22214,藤枝市'
muni['22215'] = '22,静岡県,22215,御殿場市'
muni['22216'] = '22,静岡県,22216,袋井市'
muni['22219'] = '22,静岡県,22219,下田市'
muni['22220'] = '22,静岡県,22220,裾野市'
muni['22221'] = '22,静岡県,22221,湖西市'
muni['22222'] = '22,静岡県,22222,伊豆市'
muni['22223'] = '22,静岡県,22223,御前崎市'
muni['22224'] = '22,静岡県,22224,菊川市'
muni['22225'] = '22,静岡県,22225,伊豆の国市'
muni['22226'] = '22,静岡県,22226,牧之原市'
muni['22301'] = '22,静岡県,22301,東伊豆町'
muni['22302'] = '22,静岡県,22302,河津町'
muni['22304'] = '22,静岡県,22304,南伊豆町'
muni['22305'] = '22,静岡県,22305,松崎町'
muni['22306'] = '22,静岡県,22306,西伊豆町'
muni['22325'] = '22,静岡県,22325,函南町'
muni['22341'] = '22,静岡県,22341,清水町'
muni['22342'] = '22,静岡県,22342,長泉町'
muni['22344'] = '22,静岡県,22344,小山町'
muni['22424'] = '22,静岡県,22424,吉田町'
muni['22429'] = '22,静岡県,22429,川根本町'
muni['22461'] = '22,静岡県,22461,森町'
muni['23100'] = '23,愛知県,23100,名古屋市'
muni['23101'] = '23,愛知県,23101,名古屋市　千種区'
muni['23102'] = '23,愛知県,23102,名古屋市　東区'
muni['23103'] = '23,愛知県,23103,名古屋市　北区'
muni['23104'] = '23,愛知県,23104,名古屋市　西区'
muni['23105'] = '23,愛知県,23105,名古屋市　中村区'
muni['23106'] = '23,愛知県,23106,名古屋市　中区'
muni['23107'] = '23,愛知県,23107,名古屋市　昭和区'
muni['23108'] = '23,愛知県,23108,名古屋市　瑞穂区'
muni['23109'] = '23,愛知県,23109,名古屋市　熱田区'
muni['23110'] = '23,愛知県,23110,名古屋市　中川区'
muni['23111'] = '23,愛知県,23111,名古屋市　港区'
muni['23112'] = '23,愛知県,23112,名古屋市　南区'
muni['23113'] = '23,愛知県,23113,名古屋市　守山区'
muni['23114'] = '23,愛知県,23114,名古屋市　緑区'
muni['23115'] = '23,愛知県,23115,名古屋市　名東区'
muni['23116'] = '23,愛知県,23116,名古屋市　天白区'
muni['23201'] = '23,愛知県,23201,豊橋市'
muni['23202'] = '23,愛知県,23202,岡崎市'
muni['23203'] = '23,愛知県,23203,一宮市'
muni['23204'] = '23,愛知県,23204,瀬戸市'
muni['23205'] = '23,愛知県,23205,半田市'
muni['23206'] = '23,愛知県,23206,春日井市'
muni['23207'] = '23,愛知県,23207,豊川市'
muni['23208'] = '23,愛知県,23208,津島市'
muni['23209'] = '23,愛知県,23209,碧南市'
muni['23210'] = '23,愛知県,23210,刈谷市'
muni['23211'] = '23,愛知県,23211,豊田市'
muni['23212'] = '23,愛知県,23212,安城市'
muni['23213'] = '23,愛知県,23213,西尾市'
muni['23214'] = '23,愛知県,23214,蒲郡市'
muni['23215'] = '23,愛知県,23215,犬山市'
muni['23216'] = '23,愛知県,23216,常滑市'
muni['23217'] = '23,愛知県,23217,江南市'
muni['23219'] = '23,愛知県,23219,小牧市'
muni['23220'] = '23,愛知県,23220,稲沢市'
muni['23221'] = '23,愛知県,23221,新城市'
muni['23222'] = '23,愛知県,23222,東海市'
muni['23223'] = '23,愛知県,23223,大府市'
muni['23224'] = '23,愛知県,23224,知多市'
muni['23225'] = '23,愛知県,23225,知立市'
muni['23226'] = '23,愛知県,23226,尾張旭市'
muni['23227'] = '23,愛知県,23227,高浜市'
muni['23228'] = '23,愛知県,23228,岩倉市'
muni['23229'] = '23,愛知県,23229,豊明市'
muni['23230'] = '23,愛知県,23230,日進市'
muni['23231'] = '23,愛知県,23231,田原市'
muni['23232'] = '23,愛知県,23232,愛西市'
muni['23233'] = '23,愛知県,23233,清須市'
muni['23234'] = '23,愛知県,23234,北名古屋市'
muni['23235'] = '23,愛知県,23235,弥富市'
muni['23236'] = '23,愛知県,23236,みよし市'
muni['23237'] = '23,愛知県,23237,あま市'
muni['23238'] = '23,愛知県,23238,長久手市'
muni['23302'] = '23,愛知県,23302,東郷町'
muni['23342'] = '23,愛知県,23342,豊山町'
muni['23361'] = '23,愛知県,23361,大口町'
muni['23362'] = '23,愛知県,23362,扶桑町'
muni['23424'] = '23,愛知県,23424,大治町'
muni['23425'] = '23,愛知県,23425,蟹江町'
muni['23427'] = '23,愛知県,23427,飛島村'
muni['23441'] = '23,愛知県,23441,阿久比町'
muni['23442'] = '23,愛知県,23442,東浦町'
muni['23445'] = '23,愛知県,23445,南知多町'
muni['23446'] = '23,愛知県,23446,美浜町'
muni['23447'] = '23,愛知県,23447,武豊町'
muni['23501'] = '23,愛知県,23501,幸田町'
muni['23561'] = '23,愛知県,23561,設楽町'
muni['23562'] = '23,愛知県,23562,東栄町'
muni['23563'] = '23,愛知県,23563,豊根村'
muni['24201'] = '24,三重県,24201,津市'
muni['24202'] = '24,三重県,24202,四日市市'
muni['24203'] = '24,三重県,24203,伊勢市'
muni['24204'] = '24,三重県,24204,松阪市'
muni['24205'] = '24,三重県,24205,桑名市'
muni['24207'] = '24,三重県,24207,鈴鹿市'
muni['24208'] = '24,三重県,24208,名張市'
muni['24209'] = '24,三重県,24209,尾鷲市'
muni['24210'] = '24,三重県,24210,亀山市'
muni['24211'] = '24,三重県,24211,鳥羽市'
muni['24212'] = '24,三重県,24212,熊野市'
muni['24214'] = '24,三重県,24214,いなべ市'
muni['24215'] = '24,三重県,24215,志摩市'
muni['24216'] = '24,三重県,24216,伊賀市'
muni['24303'] = '24,三重県,24303,木曽岬町'
muni['24324'] = '24,三重県,24324,東員町'
muni['24341'] = '24,三重県,24341,菰野町'
muni['24343'] = '24,三重県,24343,朝日町'
muni['24344'] = '24,三重県,24344,川越町'
muni['24441'] = '24,三重県,24441,多気町'
muni['24442'] = '24,三重県,24442,明和町'
muni['24443'] = '24,三重県,24443,大台町'
muni['24461'] = '24,三重県,24461,玉城町'
muni['24470'] = '24,三重県,24470,度会町'
muni['24471'] = '24,三重県,24471,大紀町'
muni['24472'] = '24,三重県,24472,南伊勢町'
muni['24543'] = '24,三重県,24543,紀北町'
muni['24561'] = '24,三重県,24561,御浜町'
muni['24562'] = '24,三重県,24562,紀宝町'
muni['25201'] = '25,滋賀県,25201,大津市'
muni['25202'] = '25,滋賀県,25202,彦根市'
muni['25203'] = '25,滋賀県,25203,長浜市'
muni['25204'] = '25,滋賀県,25204,近江八幡市'
muni['25206'] = '25,滋賀県,25206,草津市'
muni['25207'] = '25,滋賀県,25207,守山市'
muni['25208'] = '25,滋賀県,25208,栗東市'
muni['25209'] = '25,滋賀県,25209,甲賀市'
muni['25210'] = '25,滋賀県,25210,野洲市'
muni['25211'] = '25,滋賀県,25211,湖南市'
muni['25212'] = '25,滋賀県,25212,高島市'
muni['25213'] = '25,滋賀県,25213,東近江市'
muni['25214'] = '25,滋賀県,25214,米原市'
muni['25383'] = '25,滋賀県,25383,日野町'
muni['25384'] = '25,滋賀県,25384,竜王町'
muni['25425'] = '25,滋賀県,25425,愛荘町'
muni['25441'] = '25,滋賀県,25441,豊郷町'
muni['25442'] = '25,滋賀県,25442,甲良町'
muni['25443'] = '25,滋賀県,25443,多賀町'
muni['26100'] = '26,京都府,26100,京都市'
muni['26101'] = '26,京都府,26101,京都市　北区'
muni['26102'] = '26,京都府,26102,京都市　上京区'
muni['26103'] = '26,京都府,26103,京都市　左京区'
muni['26104'] = '26,京都府,26104,京都市　中京区'
muni['26105'] = '26,京都府,26105,京都市　東山区'
muni['26106'] = '26,京都府,26106,京都市　下京区'
muni['26107'] = '26,京都府,26107,京都市　南区'
muni['26108'] = '26,京都府,26108,京都市　右京区'
muni['26109'] = '26,京都府,26109,京都市　伏見区'
muni['26110'] = '26,京都府,26110,京都市　山科区'
muni['26111'] = '26,京都府,26111,京都市　西京区'
muni['26201'] = '26,京都府,26201,福知山市'
muni['26202'] = '26,京都府,26202,舞鶴市'
muni['26203'] = '26,京都府,26203,綾部市'
muni['26204'] = '26,京都府,26204,宇治市'
muni['26205'] = '26,京都府,26205,宮津市'
muni['26206'] = '26,京都府,26206,亀岡市'
muni['26207'] = '26,京都府,26207,城陽市'
muni['26208'] = '26,京都府,26208,向日市'
muni['26209'] = '26,京都府,26209,長岡京市'
muni['26210'] = '26,京都府,26210,八幡市'
muni['26211'] = '26,京都府,26211,京田辺市'
muni['26212'] = '26,京都府,26212,京丹後市'
muni['26213'] = '26,京都府,26213,南丹市'
muni['26214'] = '26,京都府,26214,木津川市'
muni['26303'] = '26,京都府,26303,大山崎町'
muni['26322'] = '26,京都府,26322,久御山町'
muni['26343'] = '26,京都府,26343,井手町'
muni['26344'] = '26,京都府,26344,宇治田原町'
muni['26364'] = '26,京都府,26364,笠置町'
muni['26365'] = '26,京都府,26365,和束町'
muni['26366'] = '26,京都府,26366,精華町'
muni['26367'] = '26,京都府,26367,南山城村'
muni['26407'] = '26,京都府,26407,京丹波町'
muni['26463'] = '26,京都府,26463,伊根町'
muni['26465'] = '26,京都府,26465,与謝野町'
muni['27100'] = '27,大阪府,27100,大阪市'
muni['27102'] = '27,大阪府,27102,大阪市　都島区'
muni['27103'] = '27,大阪府,27103,大阪市　福島区'
muni['27104'] = '27,大阪府,27104,大阪市　此花区'
muni['27106'] = '27,大阪府,27106,大阪市　西区'
muni['27107'] = '27,大阪府,27107,大阪市　港区'
muni['27108'] = '27,大阪府,27108,大阪市　大正区'
muni['27109'] = '27,大阪府,27109,大阪市　天王寺区'
muni['27111'] = '27,大阪府,27111,大阪市　浪速区'
muni['27113'] = '27,大阪府,27113,大阪市　西淀川区'
muni['27114'] = '27,大阪府,27114,大阪市　東淀川区'
muni['27115'] = '27,大阪府,27115,大阪市　東成区'
muni['27116'] = '27,大阪府,27116,大阪市　生野区'
muni['27117'] = '27,大阪府,27117,大阪市　旭区'
muni['27118'] = '27,大阪府,27118,大阪市　城東区'
muni['27119'] = '27,大阪府,27119,大阪市　阿倍野区'
muni['27120'] = '27,大阪府,27120,大阪市　住吉区'
muni['27121'] = '27,大阪府,27121,大阪市　東住吉区'
muni['27122'] = '27,大阪府,27122,大阪市　西成区'
muni['27123'] = '27,大阪府,27123,大阪市　淀川区'
muni['27124'] = '27,大阪府,27124,大阪市　鶴見区'
muni['27125'] = '27,大阪府,27125,大阪市　住之江区'
muni['27126'] = '27,大阪府,27126,大阪市　平野区'
muni['27127'] = '27,大阪府,27127,大阪市　北区'
muni['27128'] = '27,大阪府,27128,大阪市　中央区'
muni['27140'] = '27,大阪府,27140,堺市'
muni['27141'] = '27,大阪府,27141,堺市　堺区'
muni['27142'] = '27,大阪府,27142,堺市　中区'
muni['27143'] = '27,大阪府,27143,堺市　東区'
muni['27144'] = '27,大阪府,27144,堺市　西区'
muni['27145'] = '27,大阪府,27145,堺市　南区'
muni['27146'] = '27,大阪府,27146,堺市　北区'
muni['27147'] = '27,大阪府,27147,堺市　美原区'
muni['27202'] = '27,大阪府,27202,岸和田市'
muni['27203'] = '27,大阪府,27203,豊中市'
muni['27204'] = '27,大阪府,27204,池田市'
muni['27205'] = '27,大阪府,27205,吹田市'
muni['27206'] = '27,大阪府,27206,泉大津市'
muni['27207'] = '27,大阪府,27207,高槻市'
muni['27208'] = '27,大阪府,27208,貝塚市'
muni['27209'] = '27,大阪府,27209,守口市'
muni['27210'] = '27,大阪府,27210,枚方市'
muni['27211'] = '27,大阪府,27211,茨木市'
muni['27212'] = '27,大阪府,27212,八尾市'
muni['27213'] = '27,大阪府,27213,泉佐野市'
muni['27214'] = '27,大阪府,27214,富田林市'
muni['27215'] = '27,大阪府,27215,寝屋川市'
muni['27216'] = '27,大阪府,27216,河内長野市'
muni['27217'] = '27,大阪府,27217,松原市'
muni['27218'] = '27,大阪府,27218,大東市'
muni['27219'] = '27,大阪府,27219,和泉市'
muni['27220'] = '27,大阪府,27220,箕面市'
muni['27221'] = '27,大阪府,27221,柏原市'
muni['27222'] = '27,大阪府,27222,羽曳野市'
muni['27223'] = '27,大阪府,27223,門真市'
muni['27224'] = '27,大阪府,27224,摂津市'
muni['27225'] = '27,大阪府,27225,高石市'
muni['27226'] = '27,大阪府,27226,藤井寺市'
muni['27227'] = '27,大阪府,27227,東大阪市'
muni['27228'] = '27,大阪府,27228,泉南市'
muni['27229'] = '27,大阪府,27229,四條畷市'
muni['27230'] = '27,大阪府,27230,交野市'
muni['27231'] = '27,大阪府,27231,大阪狭山市'
muni['27232'] = '27,大阪府,27232,阪南市'
muni['27301'] = '27,大阪府,27301,島本町'
muni['27321'] = '27,大阪府,27321,豊能町'
muni['27322'] = '27,大阪府,27322,能勢町'
muni['27341'] = '27,大阪府,27341,忠岡町'
muni['27361'] = '27,大阪府,27361,熊取町'
muni['27362'] = '27,大阪府,27362,田尻町'
muni['27366'] = '27,大阪府,27366,岬町'
muni['27381'] = '27,大阪府,27381,太子町'
muni['27382'] = '27,大阪府,27382,河南町'
muni['27383'] = '27,大阪府,27383,千早赤阪村'
muni['28100'] = '28,兵庫県,28100,神戸市'
muni['28101'] = '28,兵庫県,28101,神戸市　東灘区'
muni['28102'] = '28,兵庫県,28102,神戸市　灘区'
muni['28105'] = '28,兵庫県,28105,神戸市　兵庫区'
muni['28106'] = '28,兵庫県,28106,神戸市　長田区'
muni['28107'] = '28,兵庫県,28107,神戸市　須磨区'
muni['28108'] = '28,兵庫県,28108,神戸市　垂水区'
muni['28109'] = '28,兵庫県,28109,神戸市　北区'
muni['28110'] = '28,兵庫県,28110,神戸市　中央区'
muni['28111'] = '28,兵庫県,28111,神戸市　西区'
muni['28201'] = '28,兵庫県,28201,姫路市'
muni['28202'] = '28,兵庫県,28202,尼崎市'
muni['28203'] = '28,兵庫県,28203,明石市'
muni['28204'] = '28,兵庫県,28204,西宮市'
muni['28205'] = '28,兵庫県,28205,洲本市'
muni['28206'] = '28,兵庫県,28206,芦屋市'
muni['28207'] = '28,兵庫県,28207,伊丹市'
muni['28208'] = '28,兵庫県,28208,相生市'
muni['28209'] = '28,兵庫県,28209,豊岡市'
muni['28210'] = '28,兵庫県,28210,加古川市'
muni['28212'] = '28,兵庫県,28212,赤穂市'
muni['28213'] = '28,兵庫県,28213,西脇市'
muni['28214'] = '28,兵庫県,28214,宝塚市'
muni['28215'] = '28,兵庫県,28215,三木市'
muni['28216'] = '28,兵庫県,28216,高砂市'
muni['28217'] = '28,兵庫県,28217,川西市'
muni['28218'] = '28,兵庫県,28218,小野市'
muni['28219'] = '28,兵庫県,28219,三田市'
muni['28220'] = '28,兵庫県,28220,加西市'
muni['28221'] = '28,兵庫県,28221,丹波篠山市'
muni['28222'] = '28,兵庫県,28222,養父市'
muni['28223'] = '28,兵庫県,28223,丹波市'
muni['28224'] = '28,兵庫県,28224,南あわじ市'
muni['28225'] = '28,兵庫県,28225,朝来市'
muni['28226'] = '28,兵庫県,28226,淡路市'
muni['28227'] = '28,兵庫県,28227,宍粟市'
muni['28228'] = '28,兵庫県,28228,加東市'
muni['28229'] = '28,兵庫県,28229,たつの市'
muni['28301'] = '28,兵庫県,28301,猪名川町'
muni['28365'] = '28,兵庫県,28365,多可町'
muni['28381'] = '28,兵庫県,28381,稲美町'
muni['28382'] = '28,兵庫県,28382,播磨町'
muni['28442'] = '28,兵庫県,28442,市川町'
muni['28443'] = '28,兵庫県,28443,福崎町'
muni['28446'] = '28,兵庫県,28446,神河町'
muni['28464'] = '28,兵庫県,28464,太子町'
muni['28481'] = '28,兵庫県,28481,上郡町'
muni['28501'] = '28,兵庫県,28501,佐用町'
muni['28585'] = '28,兵庫県,28585,香美町'
muni['28586'] = '28,兵庫県,28586,新温泉町'
muni['29201'] = '29,奈良県,29201,奈良市'
muni['29202'] = '29,奈良県,29202,大和高田市'
muni['29203'] = '29,奈良県,29203,大和郡山市'
muni['29204'] = '29,奈良県,29204,天理市'
muni['29205'] = '29,奈良県,29205,橿原市'
muni['29206'] = '29,奈良県,29206,桜井市'
muni['29207'] = '29,奈良県,29207,五條市'
muni['29208'] = '29,奈良県,29208,御所市'
muni['29209'] = '29,奈良県,29209,生駒市'
muni['29210'] = '29,奈良県,29210,香芝市'
muni['29211'] = '29,奈良県,29211,葛城市'
muni['29212'] = '29,奈良県,29212,宇陀市'
muni['29322'] = '29,奈良県,29322,山添村'
muni['29342'] = '29,奈良県,29342,平群町'
muni['29343'] = '29,奈良県,29343,三郷町'
muni['29344'] = '29,奈良県,29344,斑鳩町'
muni['29345'] = '29,奈良県,29345,安堵町'
muni['29361'] = '29,奈良県,29361,川西町'
muni['29362'] = '29,奈良県,29362,三宅町'
muni['29363'] = '29,奈良県,29363,田原本町'
muni['29385'] = '29,奈良県,29385,曽爾村'
muni['29386'] = '29,奈良県,29386,御杖村'
muni['29401'] = '29,奈良県,29401,高取町'
muni['29402'] = '29,奈良県,29402,明日香村'
muni['29424'] = '29,奈良県,29424,上牧町'
muni['29425'] = '29,奈良県,29425,王寺町'
muni['29426'] = '29,奈良県,29426,広陵町'
muni['29427'] = '29,奈良県,29427,河合町'
muni['29441'] = '29,奈良県,29441,吉野町'
muni['29442'] = '29,奈良県,29442,大淀町'
muni['29443'] = '29,奈良県,29443,下市町'
muni['29444'] = '29,奈良県,29444,黒滝村'
muni['29446'] = '29,奈良県,29446,天川村'
muni['29447'] = '29,奈良県,29447,野迫川村'
muni['29449'] = '29,奈良県,29449,十津川村'
muni['29450'] = '29,奈良県,29450,下北山村'
muni['29451'] = '29,奈良県,29451,上北山村'
muni['29452'] = '29,奈良県,29452,川上村'
muni['29453'] = '29,奈良県,29453,東吉野村'
muni['30201'] = '30,和歌山県,30201,和歌山市'
muni['30202'] = '30,和歌山県,30202,海南市'
muni['30203'] = '30,和歌山県,30203,橋本市'
muni['30204'] = '30,和歌山県,30204,有田市'
muni['30205'] = '30,和歌山県,30205,御坊市'
muni['30206'] = '30,和歌山県,30206,田辺市'
muni['30207'] = '30,和歌山県,30207,新宮市'
muni['30208'] = '30,和歌山県,30208,紀の川市'
muni['30209'] = '30,和歌山県,30209,岩出市'
muni['30304'] = '30,和歌山県,30304,紀美野町'
muni['30341'] = '30,和歌山県,30341,かつらぎ町'
muni['30343'] = '30,和歌山県,30343,九度山町'
muni['30344'] = '30,和歌山県,30344,高野町'
muni['30361'] = '30,和歌山県,30361,湯浅町'
muni['30362'] = '30,和歌山県,30362,広川町'
muni['30366'] = '30,和歌山県,30366,有田川町'
muni['30381'] = '30,和歌山県,30381,美浜町'
muni['30382'] = '30,和歌山県,30382,日高町'
muni['30383'] = '30,和歌山県,30383,由良町'
muni['30390'] = '30,和歌山県,30390,印南町'
muni['30391'] = '30,和歌山県,30391,みなべ町'
muni['30392'] = '30,和歌山県,30392,日高川町'
muni['30401'] = '30,和歌山県,30401,白浜町'
muni['30404'] = '30,和歌山県,30404,上富田町'
muni['30406'] = '30,和歌山県,30406,すさみ町'
muni['30421'] = '30,和歌山県,30421,那智勝浦町'
muni['30422'] = '30,和歌山県,30422,太地町'
muni['30424'] = '30,和歌山県,30424,古座川町'
muni['30427'] = '30,和歌山県,30427,北山村'
muni['30428'] = '30,和歌山県,30428,串本町'
muni['31201'] = '31,鳥取県,31201,鳥取市'
muni['31202'] = '31,鳥取県,31202,米子市'
muni['31203'] = '31,鳥取県,31203,倉吉市'
muni['31204'] = '31,鳥取県,31204,境港市'
muni['31302'] = '31,鳥取県,31302,岩美町'
muni['31325'] = '31,鳥取県,31325,若桜町'
muni['31328'] = '31,鳥取県,31328,智頭町'
muni['31329'] = '31,鳥取県,31329,八頭町'
muni['31364'] = '31,鳥取県,31364,三朝町'
muni['31370'] = '31,鳥取県,31370,湯梨浜町'
muni['31371'] = '31,鳥取県,31371,琴浦町'
muni['31372'] = '31,鳥取県,31372,北栄町'
muni['31384'] = '31,鳥取県,31384,日吉津村'
muni['31386'] = '31,鳥取県,31386,大山町'
muni['31389'] = '31,鳥取県,31389,南部町'
muni['31390'] = '31,鳥取県,31390,伯耆町'
muni['31401'] = '31,鳥取県,31401,日南町'
muni['31402'] = '31,鳥取県,31402,日野町'
muni['31403'] = '31,鳥取県,31403,江府町'
muni['32201'] = '32,島根県,32201,松江市'
muni['32202'] = '32,島根県,32202,浜田市'
muni['32203'] = '32,島根県,32203,出雲市'
muni['32204'] = '32,島根県,32204,益田市'
muni['32205'] = '32,島根県,32205,大田市'
muni['32206'] = '32,島根県,32206,安来市'
muni['32207'] = '32,島根県,32207,江津市'
muni['32209'] = '32,島根県,32209,雲南市'
muni['32343'] = '32,島根県,32343,奥出雲町'
muni['32386'] = '32,島根県,32386,飯南町'
muni['32441'] = '32,島根県,32441,川本町'
muni['32448'] = '32,島根県,32448,美郷町'
muni['32449'] = '32,島根県,32449,邑南町'
muni['32501'] = '32,島根県,32501,津和野町'
muni['32505'] = '32,島根県,32505,吉賀町'
muni['32525'] = '32,島根県,32525,海士町'
muni['32526'] = '32,島根県,32526,西ノ島町'
muni['32527'] = '32,島根県,32527,知夫村'
muni['32528'] = '32,島根県,32528,隠岐の島町'
muni['33100'] = '33,岡山県,33100,岡山市'
muni['33101'] = '33,岡山県,33101,岡山市　北区'
muni['33102'] = '33,岡山県,33102,岡山市　中区'
muni['33103'] = '33,岡山県,33103,岡山市　東区'
muni['33104'] = '33,岡山県,33104,岡山市　南区'
muni['33202'] = '33,岡山県,33202,倉敷市'
muni['33203'] = '33,岡山県,33203,津山市'
muni['33204'] = '33,岡山県,33204,玉野市'
muni['33205'] = '33,岡山県,33205,笠岡市'
muni['33207'] = '33,岡山県,33207,井原市'
muni['33208'] = '33,岡山県,33208,総社市'
muni['33209'] = '33,岡山県,33209,高梁市'
muni['33210'] = '33,岡山県,33210,新見市'
muni['33211'] = '33,岡山県,33211,備前市'
muni['33212'] = '33,岡山県,33212,瀬戸内市'
muni['33213'] = '33,岡山県,33213,赤磐市'
muni['33214'] = '33,岡山県,33214,真庭市'
muni['33215'] = '33,岡山県,33215,美作市'
muni['33216'] = '33,岡山県,33216,浅口市'
muni['33346'] = '33,岡山県,33346,和気町'
muni['33423'] = '33,岡山県,33423,早島町'
muni['33445'] = '33,岡山県,33445,里庄町'
muni['33461'] = '33,岡山県,33461,矢掛町'
muni['33586'] = '33,岡山県,33586,新庄村'
muni['33606'] = '33,岡山県,33606,鏡野町'
muni['33622'] = '33,岡山県,33622,勝央町'
muni['33623'] = '33,岡山県,33623,奈義町'
muni['33643'] = '33,岡山県,33643,西粟倉村'
muni['33663'] = '33,岡山県,33663,久米南町'
muni['33666'] = '33,岡山県,33666,美咲町'
muni['33681'] = '33,岡山県,33681,吉備中央町'
muni['34100'] = '34,広島県,34100,広島市'
muni['34101'] = '34,広島県,34101,広島市　中区'
muni['34102'] = '34,広島県,34102,広島市　東区'
muni['34103'] = '34,広島県,34103,広島市　南区'
muni['34104'] = '34,広島県,34104,広島市　西区'
muni['34105'] = '34,広島県,34105,広島市　安佐南区'
muni['34106'] = '34,広島県,34106,広島市　安佐北区'
muni['34107'] = '34,広島県,34107,広島市　安芸区'
muni['34108'] = '34,広島県,34108,広島市　佐伯区'
muni['34202'] = '34,広島県,34202,呉市'
muni['34203'] = '34,広島県,34203,竹原市'
muni['34204'] = '34,広島県,34204,三原市'
muni['34205'] = '34,広島県,34205,尾道市'
muni['34207'] = '34,広島県,34207,福山市'
muni['34208'] = '34,広島県,34208,府中市'
muni['34209'] = '34,広島県,34209,三次市'
muni['34210'] = '34,広島県,34210,庄原市'
muni['34211'] = '34,広島県,34211,大竹市'
muni['34212'] = '34,広島県,34212,東広島市'
muni['34213'] = '34,広島県,34213,廿日市市'
muni['34214'] = '34,広島県,34214,安芸高田市'
muni['34215'] = '34,広島県,34215,江田島市'
muni['34302'] = '34,広島県,34302,府中町'
muni['34304'] = '34,広島県,34304,海田町'
muni['34307'] = '34,広島県,34307,熊野町'
muni['34309'] = '34,広島県,34309,坂町'
muni['34368'] = '34,広島県,34368,安芸太田町'
muni['34369'] = '34,広島県,34369,北広島町'
muni['34431'] = '34,広島県,34431,大崎上島町'
muni['34462'] = '34,広島県,34462,世羅町'
muni['34545'] = '34,広島県,34545,神石高原町'
muni['35201'] = '35,山口県,35201,下関市'
muni['35202'] = '35,山口県,35202,宇部市'
muni['35203'] = '35,山口県,35203,山口市'
muni['35204'] = '35,山口県,35204,萩市'
muni['35206'] = '35,山口県,35206,防府市'
muni['35207'] = '35,山口県,35207,下松市'
muni['35208'] = '35,山口県,35208,岩国市'
muni['35210'] = '35,山口県,35210,光市'
muni['35211'] = '35,山口県,35211,長門市'
muni['35212'] = '35,山口県,35212,柳井市'
muni['35213'] = '35,山口県,35213,美祢市'
muni['35215'] = '35,山口県,35215,周南市'
muni['35216'] = '35,山口県,35216,山陽小野田市'
muni['35305'] = '35,山口県,35305,周防大島町'
muni['35321'] = '35,山口県,35321,和木町'
muni['35341'] = '35,山口県,35341,上関町'
muni['35343'] = '35,山口県,35343,田布施町'
muni['35344'] = '35,山口県,35344,平生町'
muni['35502'] = '35,山口県,35502,阿武町'
muni['36201'] = '36,徳島県,36201,徳島市'
muni['36202'] = '36,徳島県,36202,鳴門市'
muni['36203'] = '36,徳島県,36203,小松島市'
muni['36204'] = '36,徳島県,36204,阿南市'
muni['36205'] = '36,徳島県,36205,吉野川市'
muni['36206'] = '36,徳島県,36206,阿波市'
muni['36207'] = '36,徳島県,36207,美馬市'
muni['36208'] = '36,徳島県,36208,三好市'
muni['36301'] = '36,徳島県,36301,勝浦町'
muni['36302'] = '36,徳島県,36302,上勝町'
muni['36321'] = '36,徳島県,36321,佐那河内村'
muni['36341'] = '36,徳島県,36341,石井町'
muni['36342'] = '36,徳島県,36342,神山町'
muni['36368'] = '36,徳島県,36368,那賀町'
muni['36383'] = '36,徳島県,36383,牟岐町'
muni['36387'] = '36,徳島県,36387,美波町'
muni['36388'] = '36,徳島県,36388,海陽町'
muni['36401'] = '36,徳島県,36401,松茂町'
muni['36402'] = '36,徳島県,36402,北島町'
muni['36403'] = '36,徳島県,36403,藍住町'
muni['36404'] = '36,徳島県,36404,板野町'
muni['36405'] = '36,徳島県,36405,上板町'
muni['36468'] = '36,徳島県,36468,つるぎ町'
muni['36489'] = '36,徳島県,36489,東みよし町'
muni['37201'] = '37,香川県,37201,高松市'
muni['37202'] = '37,香川県,37202,丸亀市'
muni['37203'] = '37,香川県,37203,坂出市'
muni['37204'] = '37,香川県,37204,善通寺市'
muni['37205'] = '37,香川県,37205,観音寺市'
muni['37206'] = '37,香川県,37206,さぬき市'
muni['37207'] = '37,香川県,37207,東かがわ市'
muni['37208'] = '37,香川県,37208,三豊市'
muni['37322'] = '37,香川県,37322,土庄町'
muni['37324'] = '37,香川県,37324,小豆島町'
muni['37341'] = '37,香川県,37341,三木町'
muni['37364'] = '37,香川県,37364,直島町'
muni['37386'] = '37,香川県,37386,宇多津町'
muni['37387'] = '37,香川県,37387,綾川町'
muni['37403'] = '37,香川県,37403,琴平町'
muni['37404'] = '37,香川県,37404,多度津町'
muni['37406'] = '37,香川県,37406,まんのう町'
muni['38201'] = '38,愛媛県,38201,松山市'
muni['38202'] = '38,愛媛県,38202,今治市'
muni['38203'] = '38,愛媛県,38203,宇和島市'
muni['38204'] = '38,愛媛県,38204,八幡浜市'
muni['38205'] = '38,愛媛県,38205,新居浜市'
muni['38206'] = '38,愛媛県,38206,西条市'
muni['38207'] = '38,愛媛県,38207,大洲市'
muni['38210'] = '38,愛媛県,38210,伊予市'
muni['38213'] = '38,愛媛県,38213,四国中央市'
muni['38214'] = '38,愛媛県,38214,西予市'
muni['38215'] = '38,愛媛県,38215,東温市'
muni['38356'] = '38,愛媛県,38356,上島町'
muni['38386'] = '38,愛媛県,38386,久万高原町'
muni['38401'] = '38,愛媛県,38401,松前町'
muni['38402'] = '38,愛媛県,38402,砥部町'
muni['38422'] = '38,愛媛県,38422,内子町'
muni['38442'] = '38,愛媛県,38442,伊方町'
muni['38484'] = '38,愛媛県,38484,松野町'
muni['38488'] = '38,愛媛県,38488,鬼北町'
muni['38506'] = '38,愛媛県,38506,愛南町'
muni['39201'] = '39,高知県,39201,高知市'
muni['39202'] = '39,高知県,39202,室戸市'
muni['39203'] = '39,高知県,39203,安芸市'
muni['39204'] = '39,高知県,39204,南国市'
muni['39205'] = '39,高知県,39205,土佐市'
muni['39206'] = '39,高知県,39206,須崎市'
muni['39208'] = '39,高知県,39208,宿毛市'
muni['39209'] = '39,高知県,39209,土佐清水市'
muni['39210'] = '39,高知県,39210,四万十市'
muni['39211'] = '39,高知県,39211,香南市'
muni['39212'] = '39,高知県,39212,香美市'
muni['39301'] = '39,高知県,39301,東洋町'
muni['39302'] = '39,高知県,39302,奈半利町'
muni['39303'] = '39,高知県,39303,田野町'
muni['39304'] = '39,高知県,39304,安田町'
muni['39305'] = '39,高知県,39305,北川村'
muni['39306'] = '39,高知県,39306,馬路村'
muni['39307'] = '39,高知県,39307,芸西村'
muni['39341'] = '39,高知県,39341,本山町'
muni['39344'] = '39,高知県,39344,大豊町'
muni['39363'] = '39,高知県,39363,土佐町'
muni['39364'] = '39,高知県,39364,大川村'
muni['39386'] = '39,高知県,39386,いの町'
muni['39387'] = '39,高知県,39387,仁淀川町'
muni['39401'] = '39,高知県,39401,中土佐町'
muni['39402'] = '39,高知県,39402,佐川町'
muni['39403'] = '39,高知県,39403,越知町'
muni['39405'] = '39,高知県,39405,梼原町'
muni['39410'] = '39,高知県,39410,日高村'
muni['39411'] = '39,高知県,39411,津野町'
muni['39412'] = '39,高知県,39412,四万十町'
muni['39424'] = '39,高知県,39424,大月町'
muni['39427'] = '39,高知県,39427,三原村'
muni['39428'] = '39,高知県,39428,黒潮町'
muni['40100'] = '40,福岡県,40100,北九州市'
muni['40101'] = '40,福岡県,40101,北九州市　門司区'
muni['40103'] = '40,福岡県,40103,北九州市　若松区'
muni['40105'] = '40,福岡県,40105,北九州市　戸畑区'
muni['40106'] = '40,福岡県,40106,北九州市　小倉北区'
muni['40107'] = '40,福岡県,40107,北九州市　小倉南区'
muni['40108'] = '40,福岡県,40108,北九州市　八幡東区'
muni['40109'] = '40,福岡県,40109,北九州市　八幡西区'
muni['40130'] = '40,福岡県,40130,福岡市'
muni['40131'] = '40,福岡県,40131,福岡市　東区'
muni['40132'] = '40,福岡県,40132,福岡市　博多区'
muni['40133'] = '40,福岡県,40133,福岡市　中央区'
muni['40134'] = '40,福岡県,40134,福岡市　南区'
muni['40135'] = '40,福岡県,40135,福岡市　西区'
muni['40136'] = '40,福岡県,40136,福岡市　城南区'
muni['40137'] = '40,福岡県,40137,福岡市　早良区'
muni['40202'] = '40,福岡県,40202,大牟田市'
muni['40203'] = '40,福岡県,40203,久留米市'
muni['40204'] = '40,福岡県,40204,直方市'
muni['40205'] = '40,福岡県,40205,飯塚市'
muni['40206'] = '40,福岡県,40206,田川市'
muni['40207'] = '40,福岡県,40207,柳川市'
muni['40210'] = '40,福岡県,40210,八女市'
muni['40211'] = '40,福岡県,40211,筑後市'
muni['40212'] = '40,福岡県,40212,大川市'
muni['40213'] = '40,福岡県,40213,行橋市'
muni['40214'] = '40,福岡県,40214,豊前市'
muni['40215'] = '40,福岡県,40215,中間市'
muni['40216'] = '40,福岡県,40216,小郡市'
muni['40217'] = '40,福岡県,40217,筑紫野市'
muni['40218'] = '40,福岡県,40218,春日市'
muni['40219'] = '40,福岡県,40219,大野城市'
muni['40220'] = '40,福岡県,40220,宗像市'
muni['40221'] = '40,福岡県,40221,太宰府市'
muni['40223'] = '40,福岡県,40223,古賀市'
muni['40224'] = '40,福岡県,40224,福津市'
muni['40225'] = '40,福岡県,40225,うきは市'
muni['40226'] = '40,福岡県,40226,宮若市'
muni['40227'] = '40,福岡県,40227,嘉麻市'
muni['40228'] = '40,福岡県,40228,朝倉市'
muni['40229'] = '40,福岡県,40229,みやま市'
muni['40230'] = '40,福岡県,40230,糸島市'
muni['40231'] = '40,福岡県,40231,那珂川市'
muni['40341'] = '40,福岡県,40341,宇美町'
muni['40342'] = '40,福岡県,40342,篠栗町'
muni['40343'] = '40,福岡県,40343,志免町'
muni['40344'] = '40,福岡県,40344,須恵町'
muni['40345'] = '40,福岡県,40345,新宮町'
muni['40348'] = '40,福岡県,40348,久山町'
muni['40349'] = '40,福岡県,40349,粕屋町'
muni['40381'] = '40,福岡県,40381,芦屋町'
muni['40382'] = '40,福岡県,40382,水巻町'
muni['40383'] = '40,福岡県,40383,岡垣町'
muni['40384'] = '40,福岡県,40384,遠賀町'
muni['40401'] = '40,福岡県,40401,小竹町'
muni['40402'] = '40,福岡県,40402,鞍手町'
muni['40421'] = '40,福岡県,40421,桂川町'
muni['40447'] = '40,福岡県,40447,筑前町'
muni['40448'] = '40,福岡県,40448,東峰村'
muni['40503'] = '40,福岡県,40503,大刀洗町'
muni['40522'] = '40,福岡県,40522,大木町'
muni['40544'] = '40,福岡県,40544,広川町'
muni['40601'] = '40,福岡県,40601,香春町'
muni['40602'] = '40,福岡県,40602,添田町'
muni['40604'] = '40,福岡県,40604,糸田町'
muni['40605'] = '40,福岡県,40605,川崎町'
muni['40608'] = '40,福岡県,40608,大任町'
muni['40609'] = '40,福岡県,40609,赤村'
muni['40610'] = '40,福岡県,40610,福智町'
muni['40621'] = '40,福岡県,40621,苅田町'
muni['40625'] = '40,福岡県,40625,みやこ町'
muni['40642'] = '40,福岡県,40642,吉富町'
muni['40646'] = '40,福岡県,40646,上毛町'
muni['40647'] = '40,福岡県,40647,築上町'
muni['41201'] = '41,佐賀県,41201,佐賀市'
muni['41202'] = '41,佐賀県,41202,唐津市'
muni['41203'] = '41,佐賀県,41203,鳥栖市'
muni['41204'] = '41,佐賀県,41204,多久市'
muni['41205'] = '41,佐賀県,41205,伊万里市'
muni['41206'] = '41,佐賀県,41206,武雄市'
muni['41207'] = '41,佐賀県,41207,鹿島市'
muni['41208'] = '41,佐賀県,41208,小城市'
muni['41209'] = '41,佐賀県,41209,嬉野市'
muni['41210'] = '41,佐賀県,41210,神埼市'
muni['41327'] = '41,佐賀県,41327,吉野ヶ里町'
muni['41341'] = '41,佐賀県,41341,基山町'
muni['41345'] = '41,佐賀県,41345,上峰町'
muni['41346'] = '41,佐賀県,41346,みやき町'
muni['41387'] = '41,佐賀県,41387,玄海町'
muni['41401'] = '41,佐賀県,41401,有田町'
muni['41423'] = '41,佐賀県,41423,大町町'
muni['41424'] = '41,佐賀県,41424,江北町'
muni['41425'] = '41,佐賀県,41425,白石町'
muni['41441'] = '41,佐賀県,41441,太良町'
muni['42201'] = '42,長崎県,42201,長崎市'
muni['42202'] = '42,長崎県,42202,佐世保市'
muni['42203'] = '42,長崎県,42203,島原市'
muni['42204'] = '42,長崎県,42204,諫早市'
muni['42205'] = '42,長崎県,42205,大村市'
muni['42207'] = '42,長崎県,42207,平戸市'
muni['42208'] = '42,長崎県,42208,松浦市'
muni['42209'] = '42,長崎県,42209,対馬市'
muni['42210'] = '42,長崎県,42210,壱岐市'
muni['42211'] = '42,長崎県,42211,五島市'
muni['42212'] = '42,長崎県,42212,西海市'
muni['42213'] = '42,長崎県,42213,雲仙市'
muni['42214'] = '42,長崎県,42214,南島原市'
muni['42307'] = '42,長崎県,42307,長与町'
muni['42308'] = '42,長崎県,42308,時津町'
muni['42321'] = '42,長崎県,42321,東彼杵町'
muni['42322'] = '42,長崎県,42322,川棚町'
muni['42323'] = '42,長崎県,42323,波佐見町'
muni['42383'] = '42,長崎県,42383,小値賀町'
muni['42391'] = '42,長崎県,42391,佐々町'
muni['42411'] = '42,長崎県,42411,新上五島町'
muni['43100'] = '43,熊本県,43100,熊本市'
muni['43101'] = '43,熊本県,43101,熊本市　中央区'
muni['43102'] = '43,熊本県,43102,熊本市　東区'
muni['43103'] = '43,熊本県,43103,熊本市　西区'
muni['43104'] = '43,熊本県,43104,熊本市　南区'
muni['43105'] = '43,熊本県,43105,熊本市　北区'
muni['43202'] = '43,熊本県,43202,八代市'
muni['43203'] = '43,熊本県,43203,人吉市'
muni['43204'] = '43,熊本県,43204,荒尾市'
muni['43205'] = '43,熊本県,43205,水俣市'
muni['43206'] = '43,熊本県,43206,玉名市'
muni['43208'] = '43,熊本県,43208,山鹿市'
muni['43210'] = '43,熊本県,43210,菊池市'
muni['43211'] = '43,熊本県,43211,宇土市'
muni['43212'] = '43,熊本県,43212,上天草市'
muni['43213'] = '43,熊本県,43213,宇城市'
muni['43214'] = '43,熊本県,43214,阿蘇市'
muni['43215'] = '43,熊本県,43215,天草市'
muni['43216'] = '43,熊本県,43216,合志市'
muni['43348'] = '43,熊本県,43348,美里町'
muni['43364'] = '43,熊本県,43364,玉東町'
muni['43367'] = '43,熊本県,43367,南関町'
muni['43368'] = '43,熊本県,43368,長洲町'
muni['43369'] = '43,熊本県,43369,和水町'
muni['43403'] = '43,熊本県,43403,大津町'
muni['43404'] = '43,熊本県,43404,菊陽町'
muni['43423'] = '43,熊本県,43423,南小国町'
muni['43424'] = '43,熊本県,43424,小国町'
muni['43425'] = '43,熊本県,43425,産山村'
muni['43428'] = '43,熊本県,43428,高森町'
muni['43432'] = '43,熊本県,43432,西原村'
muni['43433'] = '43,熊本県,43433,南阿蘇村'
muni['43441'] = '43,熊本県,43441,御船町'
muni['43442'] = '43,熊本県,43442,嘉島町'
muni['43443'] = '43,熊本県,43443,益城町'
muni['43444'] = '43,熊本県,43444,甲佐町'
muni['43447'] = '43,熊本県,43447,山都町'
muni['43468'] = '43,熊本県,43468,氷川町'
muni['43482'] = '43,熊本県,43482,芦北町'
muni['43484'] = '43,熊本県,43484,津奈木町'
muni['43501'] = '43,熊本県,43501,錦町'
muni['43505'] = '43,熊本県,43505,多良木町'
muni['43506'] = '43,熊本県,43506,湯前町'
muni['43507'] = '43,熊本県,43507,水上村'
muni['43510'] = '43,熊本県,43510,相良村'
muni['43511'] = '43,熊本県,43511,五木村'
muni['43512'] = '43,熊本県,43512,山江村'
muni['43513'] = '43,熊本県,43513,球磨村'
muni['43514'] = '43,熊本県,43514,あさぎり町'
muni['43531'] = '43,熊本県,43531,苓北町'
muni['44201'] = '44,大分県,44201,大分市'
muni['44202'] = '44,大分県,44202,別府市'
muni['44203'] = '44,大分県,44203,中津市'
muni['44204'] = '44,大分県,44204,日田市'
muni['44205'] = '44,大分県,44205,佐伯市'
muni['44206'] = '44,大分県,44206,臼杵市'
muni['44207'] = '44,大分県,44207,津久見市'
muni['44208'] = '44,大分県,44208,竹田市'
muni['44209'] = '44,大分県,44209,豊後高田市'
muni['44210'] = '44,大分県,44210,杵築市'
muni['44211'] = '44,大分県,44211,宇佐市'
muni['44212'] = '44,大分県,44212,豊後大野市'
muni['44213'] = '44,大分県,44213,由布市'
muni['44214'] = '44,大分県,44214,国東市'
muni['44322'] = '44,大分県,44322,姫島村'
muni['44341'] = '44,大分県,44341,日出町'
muni['44461'] = '44,大分県,44461,九重町'
muni['44462'] = '44,大分県,44462,玖珠町'
muni['45201'] = '45,宮崎県,45201,宮崎市'
muni['45202'] = '45,宮崎県,45202,都城市'
muni['45203'] = '45,宮崎県,45203,延岡市'
muni['45204'] = '45,宮崎県,45204,日南市'
muni['45205'] = '45,宮崎県,45205,小林市'
muni['45206'] = '45,宮崎県,45206,日向市'
muni['45207'] = '45,宮崎県,45207,串間市'
muni['45208'] = '45,宮崎県,45208,西都市'
muni['45209'] = '45,宮崎県,45209,えびの市'
muni['45341'] = '45,宮崎県,45341,三股町'
muni['45361'] = '45,宮崎県,45361,高原町'
muni['45382'] = '45,宮崎県,45382,国富町'
muni['45383'] = '45,宮崎県,45383,綾町'
muni['45401'] = '45,宮崎県,45401,高鍋町'
muni['45402'] = '45,宮崎県,45402,新富町'
muni['45403'] = '45,宮崎県,45403,西米良村'
muni['45404'] = '45,宮崎県,45404,木城町'
muni['45405'] = '45,宮崎県,45405,川南町'
muni['45406'] = '45,宮崎県,45406,都農町'
muni['45421'] = '45,宮崎県,45421,門川町'
muni['45429'] = '45,宮崎県,45429,諸塚村'
muni['45430'] = '45,宮崎県,45430,椎葉村'
muni['45431'] = '45,宮崎県,45431,美郷町'
muni['45441'] = '45,宮崎県,45441,高千穂町'
muni['45442'] = '45,宮崎県,45442,日之影町'
muni['45443'] = '45,宮崎県,45443,五ヶ瀬町'
muni['46201'] = '46,鹿児島県,46201,鹿児島市'
muni['46203'] = '46,鹿児島県,46203,鹿屋市'
muni['46204'] = '46,鹿児島県,46204,枕崎市'
muni['46206'] = '46,鹿児島県,46206,阿久根市'
muni['46208'] = '46,鹿児島県,46208,出水市'
muni['46210'] = '46,鹿児島県,46210,指宿市'
muni['46213'] = '46,鹿児島県,46213,西之表市'
muni['46214'] = '46,鹿児島県,46214,垂水市'
muni['46215'] = '46,鹿児島県,46215,薩摩川内市'
muni['46216'] = '46,鹿児島県,46216,日置市'
muni['46217'] = '46,鹿児島県,46217,曽於市'
muni['46218'] = '46,鹿児島県,46218,霧島市'
muni['46219'] = '46,鹿児島県,46219,いちき串木野市'
muni['46220'] = '46,鹿児島県,46220,南さつま市'
muni['46221'] = '46,鹿児島県,46221,志布志市'
muni['46222'] = '46,鹿児島県,46222,奄美市'
muni['46223'] = '46,鹿児島県,46223,南九州市'
muni['46224'] = '46,鹿児島県,46224,伊佐市'
muni['46225'] = '46,鹿児島県,46225,姶良市'
muni['46303'] = '46,鹿児島県,46303,三島村'
muni['46304'] = '46,鹿児島県,46304,十島村'
muni['46392'] = '46,鹿児島県,46392,さつま町'
muni['46404'] = '46,鹿児島県,46404,長島町'
muni['46452'] = '46,鹿児島県,46452,湧水町'
muni['46468'] = '46,鹿児島県,46468,大崎町'
muni['46482'] = '46,鹿児島県,46482,東串良町'
muni['46490'] = '46,鹿児島県,46490,錦江町'
muni['46491'] = '46,鹿児島県,46491,南大隅町'
muni['46492'] = '46,鹿児島県,46492,肝付町'
muni['46501'] = '46,鹿児島県,46501,中種子町'
muni['46502'] = '46,鹿児島県,46502,南種子町'
muni['46505'] = '46,鹿児島県,46505,屋久島町'
muni['46523'] = '46,鹿児島県,46523,大和村'
muni['46524'] = '46,鹿児島県,46524,宇検村'
muni['46525'] = '46,鹿児島県,46525,瀬戸内町'
muni['46527'] = '46,鹿児島県,46527,龍郷町'
muni['46529'] = '46,鹿児島県,46529,喜界町'
muni['46530'] = '46,鹿児島県,46530,徳之島町'
muni['46531'] = '46,鹿児島県,46531,天城町'
muni['46532'] = '46,鹿児島県,46532,伊仙町'
muni['46533'] = '46,鹿児島県,46533,和泊町'
muni['46534'] = '46,鹿児島県,46534,知名町'
muni['46535'] = '46,鹿児島県,46535,与論町'
muni['47201'] = '47,沖縄県,47201,那覇市'
muni['47205'] = '47,沖縄県,47205,宜野湾市'
muni['47207'] = '47,沖縄県,47207,石垣市'
muni['47208'] = '47,沖縄県,47208,浦添市'
muni['47209'] = '47,沖縄県,47209,名護市'
muni['47210'] = '47,沖縄県,47210,糸満市'
muni['47211'] = '47,沖縄県,47211,沖縄市'
muni['47212'] = '47,沖縄県,47212,豊見城市'
muni['47213'] = '47,沖縄県,47213,うるま市'
muni['47214'] = '47,沖縄県,47214,宮古島市'
muni['47215'] = '47,沖縄県,47215,南城市'
muni['47301'] = '47,沖縄県,47301,国頭村'
muni['47302'] = '47,沖縄県,47302,大宜味村'
muni['47303'] = '47,沖縄県,47303,東村'
muni['47306'] = '47,沖縄県,47306,今帰仁村'
muni['47308'] = '47,沖縄県,47308,本部町'
muni['47311'] = '47,沖縄県,47311,恩納村'
muni['47313'] = '47,沖縄県,47313,宜野座村'
muni['47314'] = '47,沖縄県,47314,金武町'
muni['47315'] = '47,沖縄県,47315,伊江村'
muni['47324'] = '47,沖縄県,47324,読谷村'
muni['47325'] = '47,沖縄県,47325,嘉手納町'
muni['47326'] = '47,沖縄県,47326,北谷町'
muni['47327'] = '47,沖縄県,47327,北中城村'
muni['47328'] = '47,沖縄県,47328,中城村'
muni['47329'] = '47,沖縄県,47329,西原町'
muni['47348'] = '47,沖縄県,47348,与那原町'
muni['47350'] = '47,沖縄県,47350,南風原町'
muni['47353'] = '47,沖縄県,47353,渡嘉敷村'
muni['47354'] = '47,沖縄県,47354,座間味村'
muni['47355'] = '47,沖縄県,47355,粟国村'
muni['47356'] = '47,沖縄県,47356,渡名喜村'
muni['47357'] = '47,沖縄県,47357,南大東村'
muni['47358'] = '47,沖縄県,47358,北大東村'
muni['47359'] = '47,沖縄県,47359,伊平屋村'
muni['47360'] = '47,沖縄県,47360,伊是名村'
muni['47361'] = '47,沖縄県,47361,久米島町'
muni['47362'] = '47,沖縄県,47362,八重瀬町'
muni['47375'] = '47,沖縄県,47375,多良間村'
muni['47381'] = '47,沖縄県,47381,竹富町'
muni['47382'] = '47,沖縄県,47382,与那国町'

export default muni
